rwgps = window.rwgps || {};

rwgps.actions = rwgpsG_js_maps_actions;
rwgps.actionsManager = new rwgps.actions.ActionsManager();

rwgps.Map = function(opts) {
  //http://spreadsheets.google.com/pub?key=0Ah0xU81penP1cDlwZHdzYWkyaERNc0xrWHNvTTA1S1E&gid=1
  this.language = opts.language || rwgps.config.language || "en";
  //http://code.google.com/apis/maps/documentation/geocoding/#RegionCodes
  //"no" for norway, "co.uk" for GB
  if(opts.region)
    this.region = opts.region
  else
    this.region = 'en-us';

  this.opts = opts;
  this.mode = opts["mode"];
  this.surfaceTypesDebug = opts['surfaceTypesDebug'];
  this.prevClick = null;
  this.routes = [];
  this.setActiveRoute(new rwgps.Route(null, this));
  this.pointsOfInterest = [];
  this.poisById = {}; // data structure of convenience - not guaranteed to have all pois known about so dont rely on it unless you know it is populated with what you want
  this.gmap = null;
  this.nearestMousePoint1 = null;
  this.nearestInterpolatedMousePoint = null;
  this.nearestPointMarker = null;
  this.routePoints = null;
  this.coursePointPopup = new rwgps.CoursePointPopup(this);
  this.distanceMarkers = [[],[], [], []];
  this.nearestRouteSearchOpts = {};
  this.clicks = [];
  this.showCoursePointIcons = false;
  this.routers = {};
  this.overlays = {};
  this.activeOverlays = [];
  this.clickOptions = new rwgps.ClickOptions();
  this.clickOptions.followRoads(opts["followRoads"]);
  this.plannerOptions = new rwgps.Bitmask.Planner();
  this.lineColor = 0xff0000;

  _.bindAll(this, 'addControlPointAtIndex', 'addCoursePointAtIndex');

  //used for bringing markers to the front.  set arbitrarily high and
  //when we want a marker to front, we increment this by one and set
  //that marker to the new number.
  this.topZIndex = 1000;

  //used to place layers properly above the basemap, which is also
  //important for prioritizing routing engines between layers
  this.nextAvailableOverlayIndex = 0;

  this.routingOpts = {
    allRestrictions: ["avoidHighways"],
    services: [
      { id: "rwgps",
        enabled: true,
        defaultColor: 0xFF0000,
        type: "rwgps",
        text: T.t('routes.follow_roads'),
        defaultMode: "cycling",
        checkboxes: {avoidHighways: false},
        language: this.language,
        modes: {
          walking: { text: "walking", attributes: {} },
          cycling: { text: "cycling", attributes: {} },
          driving: { text: "driving", attributes: {} },
          experiment: { text: "experiment", attributes: {} }
        }
      },
      { id: "google",
        type: "google",
        enabled: true,
        defaultColor: 0xFF0000,
        text: T.t('routes.follow_roads'),
        defaultMode: "cycling",
        checkboxes: {avoidHighways: true},
        modes: {
          walking: { text: "walking", attributes: {avoidHighways: true} },
          cycling: { text: "cycling", attributes: {avoidHighways: true} },
          driving: { text: "driving", attributes: {avoidHighways: true} }
        }
      },
      { id: "esriTopo",
        type: "arcgis",
        text: "Follow Roads",
        enabled: true,
        defaultColor: 0xFF0000,
        url: "http://tasks.arcgisonline.com/ArcGIS/rest/services/NetworkAnalysis/ESRI_Route_NA/NAServer/Route",
        defaultMode: "cycling",
        attributes: {
          weightedCost: "",
          distanceCost: "Length",
          avoidOneWays: "OneWay",
          avoidFerries: "Avoid Ferries",
          avoidDirtRoads: "Avoid Unpaved Roads"
        },
        checkboxes: {
          avoidFerries: true,
          avoidOneWays: true,
          avoidDirtRoads: true
        },
        modes: {
          walking: { text: "walking", attributes: {avoidHighways: false}},
          cycling: { text: "cycling", attributes: {avoidHighways: true} },
          driving: { text: "driving", attributes: {avoidHighways: true} }
        }
      }
    ]
  }
  this.overlayOpts = {
    services: [
      { id: "roadmap", enabled: true, routingService: "google", type: "google" },
      { id: "terrain", enabled: true, routingService: "google", type: "google" },
      { id: "satellite", enabled: true, routingService: "google", type: "google" },
      { id: "hybrid", enabled: true, routingService: "google", type: "google" },
      { id: "rwgps_cycle",
        name: "RWGPS Cycle",
        maxZoom: 18,
        minZoom: 3,
        enabled: true,
        type: "osm",
        url: "//vector.ridewithgps.com/styles/rwgpscycle/",
        routingService: "rwgps",
        attribution: "© OpenStreetMap contributors"
      },
      { id: "osm",
        name: "OSM",
        maxZoom: 18,
        minZoom: 3,
        enabled: true,
        type: "osm",
        url: "//{s}.tile.openstreetmap.org/",
        routingService: "rwgps",
        attribution: "© OpenStreetMap contributors"
      },
      { id: "osmCycle",
        name: 'OSM Cycle',
        key: "a1f31ce03c41486894ffd9ed393ec1ea",
        maxZoom: 18,
        minZoom: 3,
        enabled: true,
        type: "osm",
        url: "//{s}.tile.thunderforest.com/cycle/",
        routingService: "rwgps",
        attribution: "© OpenStreetMap contributors"
      },
      { id: "osmOutdoor",
        name: 'OSM Outdoors',
        key: "a1f31ce03c41486894ffd9ed393ec1ea",
        maxZoom: 18,
        minZoom: 3,
        enabled: true,
        type: "osm",
        url: "//{s}.tile.thunderforest.com/outdoors/",
        routingService: "rwgps",
        attribution: "© OpenStreetMap contributors"
      },
      { id: "esriTopo",
        name: 'Esri Topo',
        maxZoom: 17,
        minZoom: 3,
        enabled: true,
        type: "arcgis",
        token: "AAPKb6d4ab91f6e249cda7f327bd40bc7a96xleixXTS5WctfNhsnl1TBpAX_vWdHu70IhznPJaqzUsjvRzBJvhmorfduBFxNhch",
        url: "//server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer",
        routingService: "rwgps"
      },
      { id: "usgsTopo",
        name: 'USGS Topo',
        maxZoom: 15,
        minZoom: 3,
        enabled: true,
        type: "arcgis",
        url: "//basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer",
        routingService: "rwgps"
      },
      { id: "usgsTopoLegacy",
        name: 'USGS Scans',
        maxZoom: 15,
        minZoom: 3,
        enabled: true,
        type: "wms",
        token: "AAPKb6d4ab91f6e249cda7f327bd40bc7a96xleixXTS5WctfNhsnl1TBpAX_vWdHu70IhznPJaqzUsjvRzBJvhmorfduBFxNhch",
        url: "//services.arcgisonline.com/arcgis/rest/services/USA_Topo_Maps/MapServer/export",
        routingService: "rwgps"
      }
    ],
    modes: {
      walking: {
        avoidCarsOnly: true,
        avoidHighways: true,
        avoidTunnels: true
      },
      cycling: {
        avoidCarsOnly: true,
        avoidHighways: true,
        avoidTunnels: true,
        avoidTrails: true
      },
      driving: { }
    }
  }

  var self = this;
  _.each(this.routingOpts.services, function(service) {
    if(opts.modePreference && service.modes[opts.modePreference])
      service.defaultMode = opts.modePreference;
    if(service.enabled == true)
      self.routers[service.id] = new rwgps.Router(service);
  });

  _.each(this.overlayOpts.services, function(service) {
    if(service.enabled == true)// && service.type != "google")
      self.overlays[service.id] = new rwgps.Overlay(service);
  });

  this.initmap();
}

// Spur correction. See https://github.com/ridewithgps/RWGPS-Android/pull/1874 for original implementation
// This version does not include the following:
// - Spur correction on drag/drop (only happens on clicking to add to route)
// - Mixed routing types. Will not correct spurs in between cycling/walking/driving/draw-lines modes.
// - Recursive spur correction. The app implementation will repeat the spur correction a few times if necessary. This version only runs once.
;(function () { // eslint-disable-line
  const reversePointAt = (seg, i) => {
    let tp
    if (i === 0) {
      tp = seg.nextControlPoint
    } else if (i === (seg.trackPoints.length + 1)) {
      tp = seg.prevControlPoint
    } else {
      tp = seg.trackPoints[seg.trackPoints.length - i]
    }
    return tp ? {point: tp.point, distance: seg.nextControlPoint.distance - tp.distance} : null
  }

  const pointAt = (seg, i) => {
    let tp
    if (i === 0) {
      tp = seg.prevControlPoint
    } else if (i === (seg.trackPoints.length + 1)) {
      tp = seg.nextControlPoint
    } else {
      tp = seg.trackPoints[i - 1]
    }
    return tp ? {point: tp.point, distance: tp.distance - seg.prevControlPoint.distance} : null
  }

  const spurStepper = (seg, reverse) => {
    const getPoint = (i) => (reverse ? reversePointAt : pointAt)(seg, i)
    return {
      index: 0, distance: 0, prevPoint: getPoint(0), nextPoint: getPoint(1), getPoint
    }
  }

  const advanceTo = ({index, distance, prevPoint, nextPoint, getPoint}, newDistance) => {
    if (newDistance < distance) {
      return
    }

    let idx = index
    let newNextPoint = nextPoint
    let newPrevPoint = prevPoint
    while (newNextPoint.distance < newDistance || newNextPoint.distance <= distance) {
      idx++
      newPrevPoint = newNextPoint
      newNextPoint = getPoint(idx + 1)
      if (!newNextPoint) return
    }

    return {
      index: idx, distance: newDistance, prevPoint: newPrevPoint, nextPoint: newNextPoint, getPoint
    }
  }

  const angleBetweenPoints = (pointA, pointB) => {
    const lat1 = pointA.lat * Math.PI / 180
    const lng1 = pointA.lng * Math.PI / 180
    const lat2 = pointB.lat * Math.PI / 180
    const lng2 = pointB.lng * Math.PI / 180

    const dLng = lng2 - lng1
    const y = Math.sin(dLng) * Math.cos(lat2)
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng)

    const theta = Math.atan2(y, x)

    const degrees = (theta * 180 / Math.PI + 360) % 360

    return degrees
  }

  const currPoint = ({prevPoint, nextPoint, distance}) => {
    const delta = (nextPoint.distance - prevPoint.distance)
    const pct = delta > 0 ? (distance - prevPoint.distance) / delta : 0
    return {
      lat: (nextPoint.point.lat - prevPoint.point.lat) * pct + prevPoint.point.lat,
      lng: (nextPoint.point.lng - prevPoint.point.lng) * pct + prevPoint.point.lng
    }
  }

  const SPUR_COINCIDENT_MAX_METERS = 10.0
  const SPUR_MAX_METERS = 75.0

  const findSpurLength = (prevSeg) => {
    let reverseSeg = spurStepper(prevSeg, true)
    let forwardSeg = spurStepper(prevSeg.nextSegment)
    let lastCoincidentDist = null

    while (true) { // eslint-disable-line
      // Find the closest next "real" point on either segment, and advance both to that point
      if (!reverseSeg.nextPoint || !forwardSeg.nextPoint) break
      const nextDist0 = reverseSeg.nextPoint.distance
      const nextDist1 = forwardSeg.nextPoint.distance
      const nextDist = Math.min(nextDist0, nextDist1)
      reverseSeg = advanceTo(reverseSeg, nextDist)
      forwardSeg = advanceTo(forwardSeg, nextDist)
      if (!reverseSeg || !forwardSeg) {
        // An entire segment is overlapping. There is a good chance this is deliberate (double-backing on a route and clicking close together) - don't detect a spur
        lastCoincidentDist = null
        break
      }

      // If our current endpoints have diverged, return the current result.
      const delta = rwgps.TrackPoint.prototype.distanceFromLatLng.call({point: currPoint(forwardSeg)}, currPoint(reverseSeg))

      // If we don't have an acute angle at the control point (vast majority of spurs are 0deg, total overlap)
      // there is a good chance we're just detecting dense trackpoints near the control point, not a spur.
      if (!lastCoincidentDist) {
        const angleA = angleBetweenPoints(prevSeg.nextControlPoint.point, currPoint(reverseSeg))
        const angleB = angleBetweenPoints(prevSeg.nextControlPoint.point, currPoint(forwardSeg))
        let angleBetween = Math.abs(angleA - angleB)
        if (angleBetween > 180) {
          angleBetween = Math.abs(angleBetween - 360)
        }
        if (angleBetween > 70) {
          break;
        }
      }

      if (delta > SPUR_COINCIDENT_MAX_METERS) {
        break
      }

      // If our endpoints are outside our max spur distance, this isn't a spur.
      if (reverseSeg.distance > SPUR_MAX_METERS) {
        lastCoincidentDist = null
        break
      }

      lastCoincidentDist = reverseSeg.distance
    }

    return lastCoincidentDist
  }

  const pointAtDistance = (segment, distance) => {
    let left = segment.prevControlPoint
    let right = segment.trackPoints.length > 0 ? segment.trackPoints[0] : segment.nextControlPoint
    for (let i = 1; distance > right.distance && i < segment.trackPoints.length; i++) {
      left = right
      right = segment.trackPoints[i]
    }
    if (distance > right.distance) {
      left = right
      right = segment.nextControlPoint
    }
    const pct = (distance - left.distance) / (right.distance - left.distance)
    return {
      lat: (right.point.lat - left.point.lat) * pct + left.point.lat,
      lng: (right.point.lng - left.point.lng) * pct + left.point.lng
    }
  }

  const FIX_BUFFER_METERS = 10.0 // How far to rewind before the spur started
  const spurReroutePoints = (prevSeg, spurLength) => {
    const fixPoint = pointAtDistance(prevSeg, prevSeg.nextControlPoint.distance - spurLength - FIX_BUFFER_METERS)
    return [prevSeg.prevControlPoint.point, fixPoint, prevSeg.nextSegment.nextControlPoint.point]
  }

  const requestRoute = (prevSeg, path, opts, color, silent, onComplete) => {
    const map = Routes.activeMap
    const service = map.activeRoutingService
    service.getDirections(path, opts, color,
      function(tps, cps) {
        if(tps == null || tps.length == 0) return;
        if(!map.opts.generateCues)
          cps = null;
        let closestIdx = 0;
        let closestDist = Infinity;
        for(let i = 0; i < tps.length; i++) {
          const dist = rwgps.TrackPoint.prototype.distanceFromLatLng.call({point: path[1]}, tps[i].point)
          if(dist < closestDist) {
            closestDist = dist;
            closestIdx = i;
          }
        }
        prevSeg.removeFromMap()
        prevSeg.nextSegment.removeFromMap()
        const newFirstSeg = new rwgps.Segment(
          map.activeRoute,
          prevSeg.prevControlPoint,
          prevSeg.nextSegment.nextControlPoint,
          tps,
          cps,
          prevSeg.color
        )
        newFirstSeg.clickOptions.setOptions(prevSeg.clickOptions.getOptions());
        newFirstSeg.splitAfter(closestIdx-1);

        const trackPoints = newFirstSeg.route.trackPoints()
        const ptsToFetch = []
        for(let i = 0; i < trackPoints.length; i++) {
          if(trackPoints[i].ele == undefined || trackPoints[i].ele == null) ptsToFetch.push(trackPoints[i]);
        }
        if(ptsToFetch.length > 0 && !silent) {
          map.fetchElevations(ptsToFetch, () => {
            map.loadElevationProfile();
            map.relabel();
            map.activeRoute.calculateMetrics();
            map.activeRoute.rebuildBounds();
            map.activeRoute.flattenBridgesAndTunnels();
            map.drawRouteDistanceMarkers(map.activeRoute);
            map.drawCoursePointIcons(map.activeRoute.coursePoints());
            map.populateCuesheet(map.activeRoute.coursePoints());
            map.snapshot();
            $.jGrowl(T.t('routes.new.spur_corrected'))
            onComplete && onComplete(newFirstSeg)
          })
        } else {
          map.activeRoute.calculateMetrics();
          onComplete && onComplete(newFirstSeg)
        }
      }, function() { onComplete && onComplete() }
    )
  }

  const checkSpur = (prevSeg, silent, callback) => {
    // require existence of a next segment
    if (!prevSeg.nextSegment) {
      callback && callback()
      return
    }
    // require same routing options
    if (!prevSeg.clickOptions.followRoads() || prevSeg.clickOptions.getOptions() !== prevSeg.nextSegment.clickOptions.getOptions()) {
      callback && callback()
      return
    }
    const spurLength = findSpurLength(prevSeg)
    if (spurLength) {
      const requestPoints = spurReroutePoints(prevSeg, spurLength)
      requestRoute(prevSeg, requestPoints, prevSeg.clickOptions, prevSeg.color, silent, (newPrevSeg) => {
        // sometimes the returned route still has a spur (it rewinds right into an intersection)
        // running this one more time fixes it.
        const spurLength = newPrevSeg ? findSpurLength(newPrevSeg) : null
        if (spurLength) {
          const requestPoints = spurReroutePoints(newPrevSeg, spurLength)
          requestRoute(newPrevSeg, requestPoints, newPrevSeg.clickOptions, newPrevSeg.color, silent, callback)
        } else {
          callback && callback()
        }
      })
    } else {
      callback && callback()
    }
  }

  rwgps.checkSpur = checkSpur
})()

rwgps.Map.prototype = {
  routes: [],
  drawGrid: function() {
    var bounds = this.gmap.getBounds(), i;
    var tr = bounds.getNorthEast(),
      bl = bounds.getSouthWest();
    var latDiff = tr.lat() - bl.lat(),
      lngDiff = tr.lng() - bl.lng(),
      cut;
    for(i = 0; i < latDiff; i++) {
      cut = Math.ceil(bl.lat() + i);
      if(cut <= tr.lat()) {
        //trace("drawing lat cut: " + cut)
        new google.maps.Polyline({
          map: this.gmap,
          path: [new google.maps.LatLng(cut, bl.lng()), new google.maps.LatLng(cut, tr.lng())],
          strokeColor: "#0000FF",
          strokeOpacity: 1,
          strokeWeight: 1,
          clickable: false
        });
      }
    }
    for(i = 0; i < lngDiff; i++) {
      cut = Math.ceil(bl.lng() + i);
      if(cut <= tr.lng()) {
        //trace("drawing lng cut: " + cut)
        new google.maps.Polyline({
          map: this.gmap,
          path: [new google.maps.LatLng(bl.lat(), cut), new google.maps.LatLng(tr.lat(), cut)],
          strokeColor: "#0000FF",
          strokeOpacity: 1,
          strokeWeight: 1,
          clickable: false
        });
      }
    }
  },
  inPlanningMode: function() {
    return this.mode == 'plan' || this.mode == 'edit';
  },
  setRoutingMode: function(mode) {
    var m = this.activeRoutingService.opts.modes[mode];
    this.routingMode = mode;
    if(mode == "walking") {
      this.clickOptions.walkingMode(true);
    } else if(mode == "cycling") {
      this.clickOptions.cyclingMode(true);
    } else if(mode == "experiment") {
      this.clickOptions.cyclingExperimentMode(true);
    } else {
      this.clickOptions.drivingMode(true);
    }
    //TODO: should be an event and handled external from map.js, like routes/new.html.haml
    $("input.restrictions:checkbox").attr("checked", false);
    for(var i = 0; i < this.routingOpts.allRestrictions.length; i++)
      this.clickOptions.setOption(this.routingOpts.allRestrictions[i], false);
    for(var key in m.attributes) {
      var val = m.attributes[key];
      $("#" + key).attr("checked", val);
      this.clickOptions.setOption(key, val);
    }
    var $walking = $(".walking"),
      $cycling = $(".cycling"),
      $driving = $(".driving");
    $walking.removeClass('active');
    $cycling.removeClass('active');
    $driving.removeClass('active');
    $('.'+mode).addClass('active');
    rwgps.Events.trigger('map:routing_mode_change', mode);
  },

  //TODO: should not be in map.js, map.js should broadcast an event on
  //activeRoutingService being set, and new.js should handle this.
  setupInterfaceForRoutingService: function() {
    var modes = this.activeRoutingService.opts.modes;
    var $walking = $(".walking"),
      $cycling = $(".cycling"),
      $driving = $(".driving");
    if(modes.walking) {
      $walking.val(modes.walking.text).show();
    } else {
      $walking.hide();
    }
    if(modes.cycling) {
      $cycling.val(modes.cycling.text).show();
    } else {
      $cycling.hide();
    }
    if(modes.driving) {
      $driving.val(modes.driving.text).show();
    } else {
      $driving.hide();
    }
    $("#followRoadsButton").text(this.activeRoutingService.opts.text);
  },

  inactiveRoutes: function() {
    var routes = _.clone(this.routes);
    if(this.activeRoute)
      routes.splice(_.indexOf(routes, this.activeRoute), 1);
    return routes;
  },

  // setter for activeRoute that handles rendering, updating associated views, and cleaning things up
  setActiveRoute: function(r) {
    if(r === this.activeRoute) { return }
    this.zoomOut();
    if(_.indexOf(this.routes, r) === -1) this.routes.push(r);
    var lastActiveRoute = this.activeRoute;
    this.activeRoute = r;
    // make active
    r.setActive();
    // clear the active route points cache (for nearest point marker)
    delete this.routePoints;
    // set "previous click" appropriately
    var tps = r.trackPoints();
    this.prevClick = tps.length > 0 ? tps[tps.length-1].point : null;
    if(lastActiveRoute) {
      if(lastActiveRoute.trackPoints().length > 0) {
        lastActiveRoute.setInactive();
      } else {
        // nothing on this route, get rid of it.
        var idx = _.indexOf(this.routes, lastActiveRoute);
        if(idx !== -1) {
          lastActiveRoute.clearStartMarker();
          this.routes.splice(idx, 1);
        }
      }
    }

    // update everything to reflect new active route
    this.populateCuesheet(r.coursePoints());
    this.drawCoursePointIcons(r.coursePoints());
    this.loadElevationProfile();
    if (Routes.sampleGraph) {
      // regardless of previous selection, if we're activating a route with st info, enable it
      const nextShowSurface = r.showSurface && (tps.length === 0 || _.some(tps, p => p.surface));
      const enabled = Routes.sampleGraph.metricsEnabled();
      if (nextShowSurface) {
        Routes.sampleGraph.metricsEnabled(enabled.push('surfaces'))
      } else if (enabled.indexOf('surfaces') !== -1) {
        Routes.sampleGraph.metricsEnabled(enabled.remove(enabled.indexOf('surfaces'), 0));
      }
      Routes.sampleGraph.showSurface(nextShowSurface);
    }
    this.onMetricsChange();
    this.drawRouteDistanceMarkers(this.activeRoute);

    // swap global POIs
    this.loadPois(r.pois);

    // we should stop listening to the previous active route events - but we dont have a nice event system yet
    r.metricsChange($.proxy(this.onMetricsChange, this));
    rwgps.Events.trigger('map:routes_changed', this);
  },

  showAllRoutes: function(routeModels) {
    var colors = ['#FF0000', '#0000FF', '#229922', '#FFFF00', '#FF00FF', '#802A2A'];
    var extraColor = '#0077FF';
    this.clearMap();
    if (this.activeRoute) {
      this.activeRoute.setInactive()
    }

    function drawRoutes (routes) {
      // start by sorting by distance desc (long ones can completely cover short ones, so draw short ones last)
      routes = _.sortBy(routes, function(x) { return -x.get('distance'); });

      // if there are contiguous routes, get them in-order so they don't get the same color
      // this assumes there is only 1 contiguous path and the first route is included
      var contiguousThreshold = 500,
        minRouteDistance = 2000,
        toRad = Math.PI / 180;
      function isAdjacent(r1, r2, dir) {
        var prefix1='last', prefix2='first';
        if(dir < 0) {
          var tmp = prefix1;
          prefix1 = prefix2;
          prefix2 = tmp;
        }
        var lat=r1.get(prefix1+'_lat'), lng=r1.get(prefix1+'_lng');
        if(!lat || !lng) return false;

        var lat2 = r2.get(prefix2+'_lat');
        var lng2 = r2.get(prefix2+'_lng');
        if(!lat2 || !lng2) return false;

        var dist = rwgps.TrackPoint.haversine(lat*toRad, lng*toRad, lat2*toRad, lng2*toRad);
        return (dist < contiguousThreshold && r1.get('mappingRoute').metrics.distance > minRouteDistance);
      }
      function getAdjacentRoute(r, dir) {
        for(var i=0; i < routes.length; i++) {
          if(isAdjacent(r, routes[i], dir))
            return routes[i];
        }
      }
      var contiguous = [routes.shift()];
      var prev, next;
      do {
        prev = getAdjacentRoute(contiguous[0], -1);
        if(prev) {
          var i = _.indexOf(routes, prev);
          routes.splice(i, 1);
          contiguous.splice(0, 0, prev);
        }
      } while(prev);
      do {
        next = getAdjacentRoute(contiguous[contiguous.length-1], 1);
        if(next) {
          i = _.indexOf(routes, next);
          routes.splice(i, 1);
          contiguous.push(next);
        }
      } while(next);
      if(contiguous.length % colors.length == 1 && isAdjacent(contiguous[0], contiguous[contiguous.length-1], -1)) {
        // what a situation
        // all the routes form a loop, and we're going to end up making 2 contiguous routes the same color.
        // pull a new color out of our back pocket to fix this
        colors.push(extraColor);
      }

      // and bring our partitioned routes back together
      // contiguous routes are appended because we are more convinced that they got the colors right, so show them above the others.
      routes = routes.concat(contiguous);

      // and draw
      routes.forEach(function(route) {
        var mappingRoute = route.get('mappingRoute');
        mappingRoute.inactiveStyle = {
          strokeOpacity: 1,
          strokeWeight: 4,
          strokeColor: colors[0]
        };
        mappingRoute.previewStyle = {
          strokeOpacity: 1,
          strokeWeight: 4,
          strokeColor: '#000000',
          zIndex: 1000
        };
        mappingRoute.setMap(this);
        mappingRoute.active = false
        this.addRoute(mappingRoute);
        colors.push(colors.shift());
      }, this);
      this.recenterMap()
    }

    var _drawRoutes = drawRoutes.bind(this)

    async.mapLimit(routeModels, 3, function(r, cb) {
      r.full().done(function(route) {
        cb(null, route);
      });
    }, function(e, routes) {
      _drawRoutes(routes)
    });
  },
  /*
  * this.activeOverlays will contain an ordered list of the active
  * overlays.  index at 0 will always be the basemap, and anything
  * above 0 will be a layer on top of the basemap.  The top most
  * layer *with a routing service* will be the routing service we
  * use when drawing.  Some layers may not have a routing service,
  * so we look down the layer stack to find the routing service,
  * which will always at least default to the basemap's router.
  *
  * Changing basemaps is handled in the event handler mapTypeChanged,
  * which just swaps out the activeOverlay at index 0.  This is still
  * called on basemap change, as a way to reset routing options if
  * necessary.
  */
  onOverlayChanged: function(inInit = false) {
    //we want to loop through all to set our plannerOptions, but only
    //want to find the topmost routing service, so must track state
    var alreadyFound = false;

    //deselect all overlays, we will re-enable active ones next
    for(var key in this.overlays) {
      this.plannerOptions.setOption(this.overlays[key].opts.id, false);
    }

    for(var i = this.activeOverlays.length-1; i >= 0; i--) {
      var overlay = this.activeOverlays[i];

      if(!alreadyFound && overlay.opts.routingService) {
        var router = this.routers[overlay.opts.routingService];
        if(router) {
          if(router.opts && router.opts.checkboxes) {
            var opts = router.opts.checkboxes;
            for(var j = 0; j < this.routingOpts.allRestrictions.length; j++) {
              this.clickOptions.setOption(this.routingOpts.allRestrictions[j], false);
              $("#" + key).parent().toggle(false)
            }

            //TODO: should be an event and handled external from map.js, like routes/new.html.haml
            $("input.restrictions:checkbox").parent().toggle(false);
            for(key in opts) {
              //trace([key, opts[key]]);
              $("#" + key).parent().toggle(opts[key])
            }
          }
          this.activeRoutingService = router;
          this.setupInterfaceForRoutingService();
          alreadyFound = true;
        }
      }
      //make sure we have our plannerOptions properly set
      this.plannerOptions.setOption(overlay.opts.id, true);
      // don't change the routing mode if the new router supports it
      if(!this.activeRoutingService.opts.modes[this.routingMode]) {
        this.setRoutingMode(this.activeRoutingService.opts.defaultMode);
      } else {
        //reset all checkboxes with new overlay's routing defaults
        this.setRoutingMode(this.routingMode)
      }
      //removed defaultColor for now, seems confusing and we only want red ATM
      //this.setColor(this.activeRoutingService.opts.defaultColor);
    }
    var mapType = this.gmap.getMapTypeId();
    const path = window.location.pathname
    const planner_edit = /^\/routes\/\d+\/edit/.test(path) && "Edit"
    const planner_new = /^\/routes\/new/.test(path) && "New"
    const planner_type = planner_edit || planner_new
    const category = planner_type ? `Route Planner - ${planner_type}` : "Route/Trip Viewer"
    const action = inInit ? "Map Style - Initial" : "Map Style - Change"
    trackEvent(category, action, mapType)
    this.drawMapAttribution(this.overlays[mapType].opts.attribution);
    if (mapType === 'roadmap' || mapType === 'satellite' || mapType === 'hybrid' || mapType === 'terrain') {
      $('.rwgps-BikeLaneControl').show()
    } else {
      $('.rwgps-BikeLaneControl').hide()
    }
    this.opts.onOverlayChanged && this.opts.onOverlayChanged(overlay)
  },

  //TODO: Note: gmaps bike overlay isn't handled in here, it's being
  //manually toggled in the layer controls class...
  toggleOverlay: function(overlay) {
    var toggled;
    if(overlay.active == true) { //turn off the overlay
      this.gmap.overlayMapTypes.setAt(overlay.index, null);
      this.nextAvailableOverlayIndex -= 1;
      overlay.active = false;
      overlay.index = null;
      toggled = false;
      //remove the overlay from the active overlays
      this.activeOverlays.splice(_.indexOf(this.activeOverlays, overlay), 1);
    } else {
      overlay.active = true;
      overlay.index = this.nextAvailableOverlayIndex;
      this.nextAvailableOverlayIndex += 1;
      this.gmap.overlayMapTypes.setAt(overlay.index, overlay.getOverlayObj());
      toggled = true;
      //place overlay as the topmost active overlay (routing engine precedence etc)
      this.activeOverlays.push(overlay);
    }
    this.onOverlayChanged(); //resets our planner state (UI and options), caches router
    rwgps.Events.trigger("map:overlay:toggled", overlay, toggled);
    return toggled;
  },

  initmap: function() {
    var self = this, maptypes = [];
    _.each(this.overlays, function(overlay) {
      if(overlay.opts.isLayer != true) {
        if(self.opts.hideGoogleTiles && overlay.opts.type == "google") return;
        maptypes.push(overlay.opts.id);
      }
    });

    var streetViewOptions = {
        addressControlOptions : { position : google.maps.ControlPosition.BOTTOM_CENTER },
        enableCloseButton : true,
        visible: false //set to false so streetview is not triggered on the initial map load
    };

    var opts = {
      zoom: 15,
      gestureHandling: 'greedy',
      scrollwheel: this.opts.hasOwnProperty("scrollwheel") && this.opts["scrollwheel"] != true ? false : true,
      draggableCursor: "crosshair",
      fullscreenControl: this.opts.fullscreenControl !== false,
      fullscreenControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT
      },
      mapTypeControl: this.opts.hasOwnProperty("showOverlayPicker") ? (!!this.opts.showOverlayPicker) : true,
      mapTypeControlOptions: {
        mapTypeIds: maptypes,
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.TOP_RIGHT
      },
      controlSize: 25,
      streetView: new google.maps.StreetViewPanorama(document.getElementById(this.opts.targetDiv), streetViewOptions),
      mapTypeId: this.opts.overlay || google.maps.MapTypeId.ROADMAP
    }

    if (this.opts["bounds"]) {
      var sw = new google.maps.LatLng(this.opts.bounds[0].lat, this.opts.bounds[0].lng)
      var ne = new google.maps.LatLng(this.opts.bounds[1].lat, this.opts.bounds[1].lng)
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(ne)
      bounds.extend(sw)
      opts["bounds"] = bounds
    } else if (this.opts["center"]) {
      var lat = this.opts["center"]["lat"], lng = this.opts["center"]["lng"];
      opts["center"] = new google.maps.LatLng(lat, lng);
    } else { //default on portland
      opts["center"] = new google.maps.LatLng(45.5773, -122.616);
    }

    //set our planner option bitmask with the correct overlay
    if(!this.inPlanningMode()) {
      //override mapTypeId and set any overlays...
      if(this.opts.plannerOptions && this.opts.plannerOptions > 0) {
        this.plannerOptions.setOptions(this.opts.plannerOptions);
        var set = this.plannerOptions.getSetGroupOption("basemaps");
        if(set && this.overlays[set]) opts.mapTypeId = set;
      }
    }

    opts.styles = [
      {
        featureType: 'poi.business',
        elementType: 'labels',
        stylers: [
          { visibility: 'on' }
        ]
      }
    ]

    this.gmap = new google.maps.Map(document.getElementById(this.opts["targetDiv"]), opts);
    if (opts["bounds"]) {
      this.gmap.fitBounds(bounds)
    }

    if(this.inPlanningMode()) {
      this.activeOverlays.push(this.overlays[opts.mapTypeId]);
    }
    this.onOverlayChanged(true);

    //TODO: this is ghetto, but necessary for gmap WMS overlays because they require the map's
    //current projection in order to compute the bounding box of each tile at current zoom
    _.each(this.overlays, function(overlay) {
      overlay.setProvider("google", self.gmap);
    });

    for(var i = 0; i < maptypes.length; i++) {
      var t = maptypes[i];
      var base = self.overlays[t];
      if(base && base.opts.type != "google") {
        self.gmap.mapTypes.set(t, base.getOverlayObj());
      }
    }

    if (rwgps.onRightClick) {
      google.maps.event.addListener(this.gmap, 'rightclick', (e) => rwgps.onRightClick(e, 'map', this))
    }

    google.maps.event.addListenerOnce(this.gmap, 'tilesloaded', function() {
      if(self.opts.hideElevation) {
        self.hideElevation();
      }
      google.maps.event.trigger(self.gmap, 'resize');
      rwgps.Events.trigger('map:initialized');
    });
    if(window.afterExpandCollapse) {
      afterExpandCollapse(function() {
        $(window).resize();
      });
    }

    google.maps.event.addListener(this.gmap, 'zoom_changed', $.proxy(this.onMapZoom, this));
    google.maps.event.addListener(this.gmap, 'dragstart', $.proxy(this.onMapDragStart, this));
    google.maps.event.addListener(this.gmap, 'dragend', $.proxy(this.onMapDragEnd, this));
    if(this.mode == "user_edit") {
      //TODO: plain simple map...this is ugly, aybe we need a base map type that
      //the planner inherits from or something.  whatever...technical debt.
    } else if(this.mode == "preview") { // eslint-disable-line no-empty
    } else if(this.mode == "search") {
      this.drawCustomControls();
    } else { //plan or edit
      this.enableClicks(); //add click listener

      //rwgps.Events.bind("map:overlay:toggled", function(overlay, toggled) { trace([overlay, toggled]); });
      google.maps.event.addListener(this.gmap, 'maptypeid_changed', $.proxy(this.mapTypeChanged, this));
      google.maps.event.addListener(this.gmap, 'mousemove', $.proxy(this.onMouseMove, this));
      // mousemove is throttled and debounced so it might fire up to 100ms late. this screws up our ability to highlight points on the map in some circumstances (move mouse directly from map area to slideshow) so we are ignoring the debounced/throttled mousemove event for the debounce duration (100ms) on mouseout
      var that = this;
      google.maps.event.addListener(this.gmap, 'mouseout', function() {
        that.ignoreMouseMove = true;
        _.delay(function() { that.ignoreMouseMove = false; }, 100);
      });
      // as far as i can tell there is no easy way to determine if the map is totally initialized (including controls loaded) so we'll just wait impatiently to get metrics displayed...
      // NOTE: there is a way supposedly, not sure if it works with controls, but you wait until map is idle, and there is an idle event you can register for
      (function tryToShowMetrics() {
        if($('.sg-data-summary').length == 0)
          _.delay(tryToShowMetrics, 50);
        else {
          self.activeRoute.metricsChange();
        }
      })();

      this.drawCustomControls();

      // handle resize event properly, only matters if ele profile exists
      if($('body.full #elevation_profile').length > 0) {
        $(window).resize(_.debounce(function() {
          google.maps.event.trigger(self.gmap, 'resize');
          var trspNudgeHeight = ($('#rp_nudge').offset() && $('#rp_nudge').offset().top > 0) ? 62 : 0;
          var availableHeight = $(window).height() - $('.globalNav,#globalNav').get(0).getClientRects()[0].top - $('.globalNav,#globalNav').outerHeight() - trspNudgeHeight;
          $('#map').height(availableHeight);
          if(self.elevationCollapsed) {
            $('#viewport').height(availableHeight - $('#elevation_profile .sg-bar').outerHeight());
          } else {
            $('#viewport').height(availableHeight * 0.8);
            _.defer(function() {
              $('#elevation_profile').height(availableHeight * 0.2);
              if(Routes.sampleGraph) {
                Routes.sampleGraph.resize($('#elevation_profile').innerWidth(), $('#elevation_profile').innerHeight());
              }
            });
          }
        }, 100)).resize();
      }

      //redraw auto-saved route if present and its ok to do so
      if(this.mode == "plan" && !this.opts.preventLoadingLocallySavedRoute)
        this.redrawLocallySavedRoute();
    }
  },

  drawMapAttribution: function(attribution) {
    this.hideMapAttribution();

    if(!attribution) return;

    var $control = $('<div><span>'+attribution+'</span></div>');
    $control.find('span').css({
      opacity: "0.65",
      padding: "0px 2px",
      "font-family": "Roboto,Arial,sans-serif",
      "background-color": 'white',
      "font-size": "0.9em",
      "font-weight": "400",
      color: "#333333"
    }).end();

    this.mapAttributionLocation = this.gmap.controls[google.maps.ControlPosition.BOTTOM_RIGHT];
    this.mapAttributionPosition = this.mapAttributionLocation.length;
    this.mapAttributionLocation.push($control.get(0));
  },
  hideMapAttribution: function() {
    if(this.mapAttributionLocation != null && this.mapAttributionPosition != null) {
      this.mapAttributionLocation.removeAt(this.mapAttributionPosition);
      this.mapAttributionLocation = null;
      this.mapAttributionPosition = null;
    }
  },

  drawCustomControls: function() {
    if (this.opts.noCustomControls) { return }
    var bikeLaneControl = new rwgps.BikeLaneControl(this);
    this.gmap.controls[google.maps.ControlPosition.TOP_RIGHT].push(bikeLaneControl.getContainingDiv());
  },

  initializeBikeLayer: function() {
    this.bikeLayer = new google.maps.BicyclingLayer();
  },

  showBikeLayer: function() {
    if (!this.bikeLayer) {
      this.initializeBikeLayer();
    }
    this.bikeLayer.setMap(this.gmap);
    this.plannerOptions.setOption("gmapsBikeOverlay", true);
  },

  hideBikeLayer: function() {
    this.bikeLayer && this.bikeLayer.setMap(null);
    this.plannerOptions.setOption("gmapsBikeOverlay", false);
  },

  initializeHeatLayer: function() {
    const opts = {
      id: "heatMap",
      name: "Heatmap",
      maxZoom: 19,
      minZoom: 3,
      enabled: true,
      type: "osm",
      url: "//heatmap.ridewithgps.com/normalized/"
    };
    this.heatLayer = new google.maps.ImageMapType({
      getTileUrl: function(coord, zoom) {
        return opts.url + zoom + "/" + coord.x + "/" + coord.y + ".png?start_color=%23bcebf0&end_color=%23e94b65";
      },
      tileSize: new google.maps.Size(256, 256),
      isPng: true,
      alt: opts.alt,
      name: opts.name,
      maxZoom: opts.maxZoom
    });
    this.heatLayer.setOpacity(0.7);
  },

  showHeatLayer: function() {
    if (!this.heatLayer) {
      this.initializeHeatLayer();
    }
    this.gmap.overlayMapTypes.setAt(0, this.heatLayer);
    // I do not know why this is needed, and isn't needed for distance markers. But they don't re-render if you remove this.
    _.defer(() => {
      this.drawCoursePointIcons(this.activeRoute.coursePoints());
    })
  },

  hideHeatLayer: function() {
    this.gmap.overlayMapTypes.setAt(0, null);
    _.defer(() => {
      this.drawCoursePointIcons(this.activeRoute.coursePoints());
    })
  },

  toggleElevation: function() {
    if(!this.elevationCollapsed) {
      this.hideElevation();
    } else {
      this.showElevation();
    }
  },

  showElevation: function() {
    var availableHeight = $(window).height() - $('.globalNav,#globalNav').get(0).getClientRects()[0].top - $('.globalNav,#globalNav').outerHeight();
    if(Routes.sampleGraph.options.displayLightControls) {
      $('#elevation_profile').show();
    } else {
      $('#elevation_profile canvas').show();
    }
    Routes.sampleGraph.segmentSelector && Routes.sampleGraph.segmentSelector.show()
    if(Routes.elevationHeight) {
      $('#viewport').height(availableHeight - Routes.elevationHeight);
    } else {
      $('#viewport').height(availableHeight * 0.8);
    }
    google.maps.event.trigger(this.gmap, 'resize');
    this.loadElevationProfile();
    this.elevationCollapsed = false;
    $(window).resize();
  },
  hideElevation: function() {
    var val = $('.globalNav,#globalNav').get(0).getClientRects()[0].top;
    var availableHeight = $(window).height() - val - $('.globalNav,#globalNav').outerHeight();

    if(Routes.sampleGraph.options.displayLightControls) {
      $('#elevation_profile').hide();
    } else {
      $('#elevation_profile canvas').hide();
    }
    Routes.sampleGraph.segmentSelector && Routes.sampleGraph.segmentSelector.hide()
    $('#routeContainer').height('100%')
    $('#viewport').height(availableHeight - $('#elevation_profile .sg-bar').outerHeight());
    google.maps.event.trigger(this.gmap, 'resize');
    this.loadElevationProfile();
    this.elevationCollapsed = true;
  },
  onMetricsChange: function() {
    // TODO on the eventing system, let me pass arguments along with the event.. in this case, the route and/or the metrics would be nice
    var metrics = this.highlightedPoints ? this.highlightedPoints.metrics : this.activeRoute.metrics;
    $('.sg-data-summary').text(
      rwgps.LabelMaker.longLabel(metrics.distance || 0, 'short') +
      ' +' + rwgps.LabelMaker.shortLabel(metrics.ele_gain || 0, 'short') +
      ' / -' + rwgps.LabelMaker.shortLabel(metrics.ele_loss || 0, 'short') +
      (this.highlightedPoints && metrics.grade && metrics.grade.avg ? ' (' + metrics.grade.avg.toFixed(1) + '%)' : '')
    );
    rwgps.Events.trigger('metrics:changed', metrics, !!this.highlightedPoints);
  },

  initInfoWindowHandlers: function() {
    var self = this;
    // course point edit buttons
    $("#coursePointInfoWindowContent .deleteButton").click(function() {
      self.deleteCoursePoint();
      return false;
    });
    $("#coursePointInfoWindowContent .saveButton").click(function() {
      self.saveCoursePoint();
      return false;
    });
    $("#coursePointInfoWindowContent .cancelButton").click(function() {
      self.closeCoursePoint();
      return false;
    });

    $("#poiInfoWindowContent .addToPoiLibrary").click(function() {
      if ($(this).attr('data-poi_id')) {
        var saveOrUpdate = $('#saveOrUpdate');
        saveOrUpdate.css('display', this.checked ? 'inline' : 'none');
      }
    });
    // poi edit buttons
    $("#poiInfoWindowContent .deleteButton").click(function() {
      const doDelete = () => {
        var id = $(this).attr('data-poi_id'), poi = id ? self.poisById[id] : self.openPoi;
        self.deletePoi(poi);
      }
      customConfirm(T.t('confirm_delete_poi'), doDelete.bind(this))
      return false;
    });
    $("#poiInfoWindowContent .saveButton").click(function() {
      // gi doesnt want poi with blank names
      if($('#poiInfoWindowContent .poiName').val() == '') {
        customAlert(T.t('poi_name_required'));
        return false;
      }
      self.savePoi();
      return false;
    });
    $("#poiInfoWindowContent .cancelButton").click(function() {
      self.closeStickyInfoWindow();
      return false;
    });
    $('.poi_add_to_route').click(function() {
      var id = $(this).attr('data-poi_id'), poi = self.poisById[id];
      poi.addToRoute();
      return false;
    });
    $('.poi_remove_from_route').click(function() {
      var id = $(this).attr('data-poi_id'), poi = id ? self.poisById[id] : self.openPoi;
      poi.removeFromRoute();
      return false;
    });
    $('.poi_make_unique').click(function() {
      var id = $(this).attr('data-poi_id'), poi = id ? self.poisById[id] : self.openPoi;
      poi.id = null;
      poi.library = false;
      self.openStickyInfoWindow(poi)
      return false;
    });
    $('.poi_route_to').click(function() {
      var id = $(this).attr('data-poi_id'), poi = id ? self.poisById[id] : self.openPoi;
      self.onClickAddPoint({latLng: poi.marker.gmarker.position});
      poi.addToRoute();
      return false;
    });
  },
  enableClicks: function() {
    if(this.addPoiEnabled)  {
      this.enableAddPoi();
      return;
    } else if(this.addCoursePointEnabled) {
      return;
    } else if(this.addControlPointEnabled) {
      return;
    } else if(this.routeSplitterEnabled) {
      return;
    }

    // just in case, make sure clicks are disabled first so event isnt double added
    this.disableClicks();

    // also disable mouseover on pois
    this.preventPoiMouseover = false;

    if(this.inPlanningMode())
      google.maps.event.addListener(this.gmap, 'click', $.proxy(this.onClickAddPoint, this));
  },
  disableClicks: function() {
    // also disable mouseover on pois
    this.preventPoiMouseover = true;

    google.maps.event.clearListeners(this.gmap, 'click');
  },

  // disable click-to-draw-route and make the next click set up a POI
  enableAddPoi: function() {
    this.disableClicks();
    this.addPoiEnabled = true;
    google.maps.event.addListener(this.gmap, 'click', $.proxy(this.onClickAddPoi, this));
  },

  disableAddPoi: function() {
    this.addPoiEnabled = false;
    rwgps.Events.trigger("addpoi:disabled");
    this.enableClicks(); // get standard behavior back of click-to-route
  },

  onClickAddPoi: function(e) {
    this.closeStickyInfoWindow();

    var poi = new rwgps.PointOfInterest({ point: {lat: e.latLng.lat(), lng: e.latLng.lng()} });
    poi.marker = new rwgps.PoiIcon(poi, this);
    poi._new = true;
    this.pointsOfInterest.push(poi);
    if (this.activeRoute && this.activeRoute.pois) {
      this.activeRoute.pois.push(poi);
    }
    rwgps.Events.trigger('pois:added', poi);

    this.openStickyInfoWindow(poi);
  },

  inclusiveBounds: function() {
    if(this.staticBounds) return this.staticBounds;
    var bounds = new google.maps.LatLngBounds();
    _.each(this.routes, function(route) {
      if(route.active || route.drawInactive)
        bounds.union(route.gBounds);
    });
    if(this.poiGBounds)
      bounds.union(this.poiGBounds);
    return bounds;
  },

  // centers on the activeRoute, without considering anything else.
  recenterMap: function() {
    if(!this.recenterDisabled) {
      var bounds = this.inclusiveBounds();
      if(!bounds.isEmpty()) {
        this.gmap.fitBounds(this.inclusiveBounds());
      }
    }
  },

  // there are some event bindings that cause recentering.  not clear how to restructure it.
  // if you want it to not recenter, pass your function here and recentering will be temporarily
  // disabled
  withRecenterDisabled: function(fn) {
    this.recenterDisabled = true;
    fn();
    this.recenterDisabled = false;
  },

  handleClick: function(click) {
    if(this.opts.autoCenter)
      this.gmap.panTo(new google.maps.LatLng(click.point.lat, click.point.lng));

    if(this.routingRequestInProgress) {
      this.clicks.push(click);
      return;
    }

    if(this.prevClick) {
      if(click.points) {
        // points provided! no need to fetch.
        this.onRoutingSuccess(click.points, null, click.opts, click.color);
      } else if(click.opts.followRoads()) {
        var service = this.activeRoutingService;
        var directionsFn = _.bind(function() {
          service.getDirections(
            [this.prevClick, click.point],
            click.opts,
            click.color,
            $.proxy(this.onRoutingSuccess, this),
            $.proxy(this.onRoutingError, this)
          );
        }, this);
        this.routingRequestInProgress = true;
        if(click.delay) {
          setTimeout(directionsFn, click.delay);
        } else {
          directionsFn();
        }
      } else { // draw lines
        var pts = [
          new rwgps.TrackPoint({point: this.prevClick}),
          new rwgps.TrackPoint({point: click.point})
        ];
        if (rwgps.config.labs.route_planner) { // SURFACE: 99 is 'unknown'
          pts.forEach(pt => {
            pt.surface = 99;
            pt.ghSurface = 99;
          })
        }
        this.onRoutingSuccess(rwgps.Segment.fillTheCracks(pts), null, click.opts, click.color);
      }
    } else {
      this.prevClick = click.point;
      this.activeRoute.startMarker = new rwgps.StartIcon(click.point, this);
      this.snapshot();
      // we normally handle this on direction request success, but since we
      // aren't calling that, we have to explicitly handle it here
      this.dispatchNextClick();
    }
  },
  dispatchNextClick: function() {
    if(this.clicks.length > 0) {
      this.handleClick(this.clicks.shift());
    } else {
      rwgps.Events.trigger("map:clicks_dispatched");
    }
  },
  snapshot: function(opts) {
    if(this.snapshotsDisabled || !this.inPlanningMode()) return;
    if(!opts) opts = {};
    // pop this off the stack so it doesnt halt ui updates
    var map = this;
    var doSnapshot = function() {
      var serialized = {
        routes: _.map(map.routes, function(route) {
          var obj = route.toSaveObj(true);
          obj.points_of_interest = route.pois.map(poi => poi.toSaveObj());
          if(route.active && route.startMarker) {
            var latlng = route.startMarker.gmarker.getPosition();
            obj.start_point = {x: latlng.lng(), y: latlng.lat()};
          }
          obj.routeData = route.routeData;
          obj.tripData = route.tripData;
          return obj;
        })
      };
      var snapshot = new rwgps.actions.RouteSnapshot(map, serialized);

      if(opts.updateLast) {
        rwgps.actionsManager.chain(snapshot);
      } else if(opts.manualUndo) {
        rwgps.actionsManager.manualUndoTo(snapshot);
      } else {
        rwgps.actionsManager.add(snapshot);
      }
      map.saveSnapshotLocally(snapshot);
      // the active route is dirty now =(
      map.activeRoute.setModified();
    };
    if(opts.doSync)
      doSnapshot();
    else
      _.defer(doSnapshot);
  },
  saveSnapshotLocally: function(snapshot) {
    if(this.mode == "edit") return;
    if($.jStorage && $.jStorage.storageAvailable()) {
      $.jStorage.set("locallySavedRoute", snapshot.serialized);
    } else {
      trace("no local storage available?");
    }
  },
  redrawLocallySavedRoute: function() {
    try {
      if($.jStorage === undefined) return;
      var serializedSnapshot = $.jStorage.get("locallySavedRoute");
      if(serializedSnapshot) {
        var snapshot = new rwgps.actions.RouteSnapshot(this, serializedSnapshot);
        snapshot.restore();
        this.snapshot()
        this.recenterMap();
      }
    } catch(e) {
      trace(e.stack)
      trace("Error redrawing locally saved route, clearing it out");
      this.clearMap();
    }
  },

  onClickAddPoint: function(e) {
    if(this.opts.tripId) {
      rwgps.Events.trigger("trip:modification_prevented");
      return;
    }
    this.handleClick({
      point: {lat: e.latLng.lat(), lng: e.latLng.lng()},
      opts: this.clickOptions,
      color: this.lineColor,
      fetchEles: true
    });
  },
  insertPointAfterClick: function() {
    var gll = this.nearestPointMarker.gmarker.getPosition();
    var point = {lat: gll.lat(), lng: gll.lng()}
    var distance = this.nearestMousePointBehind.distance + this.nearestMousePointBehind.distanceFromLatLng(point);
    const surface = this.nearestMousePointBehind.surface,
      ghSurface = this.nearestMousePointBehind.ghSurface,
      roadClass = this.nearestMousePointBehind.roadClass,
      excludeFromMetrics = this.nearestMousePointBehind.excludeFromMetrics;
    var tp = new rwgps.TrackPoint({
      point,
      ele: this.nearestMousePointBehind.ele,
      surface: surface,
      ghSurface: ghSurface,
      roadClass: roadClass,
      excludeFromMetrics: excludeFromMetrics
    });
    tp.distance = distance;
    var prevSegment = this.nearestMousePointBehind.segment || this.nearestMousePointBehind.nextSegment;
    var idx = _.indexOf(prevSegment.trackPoints, this.nearestMousePointBehind);
    prevSegment.insertTrackPointAfter(tp, idx);
    this.fetchElevations([tp], $.proxy(function() {
      this.loadElevationProfile();
      this.snapshot({updateLast: true});
    }, this), function(msg) { trace(msg) });
    return {trackPoint: tp, idx: idx};
  },
  onClickAddCoursePoint: function() {
    var newTp = this.insertPointAfterClick().trackPoint;
    this.openCoursePointInfoWindow(new rwgps.CoursePoint({
      point: newTp.point,
      trackPoint: newTp,
      segment: newTp.segment,
      distance: newTp.distance
    }));
  },
  onClickAddControlPoint: function() {
    var ret = this.insertPointAfterClick();
    ret.trackPoint.segment.splitAfter(ret.idx);
    this.loadElevationProfile();
  },
  onNearestPointMarkerClicked: function(e) {
    if(this.activeRoute !== (this.nearestMousePointBehind.segment || this.nearestMousePointBehind.nextSegment).route) {
      // clicked on an inactive route, make active.
    } else if(this.inPlanningMode()) {
      if(this.selectionToolHelper) {
        const res = this.insertPointAfterClick();
        const closestI = this.activeRoute.trackPoints().indexOf(res.trackPoint)
        this.selectionToolHelper.selectPoint({closestI})
      } else if(this.routeSplitterEnabled)
        this.onClickSplitRoute(e);
      else if(this.addPoiEnabled)
        this.onClickAddPoi(e);
      else if(this.addCoursePointEnabled)
        this.onClickAddCoursePoint(e);
      else if(this.addControlPointEnabled)
        this.onClickAddControlPoint(e);
      else
        this.onClickAddPoint(e);
    } else {
      rwgps.Events.trigger('map:route_click', this.lastNearestPoint);
    }
  },
  onClickSplitRoute: function () {
    var splitPointResult = this.insertPointAfterClick();
    this.splitRouteOnTrackPoint(splitPointResult);
  },

  // Create two new routes on the map that are the divided copies from the current active route
  splitRouteOnTrackPoint: function (splitPointResult) {
    var wholeRoute = this.activeRoute;
    var splitPoint = splitPointResult.trackPoint;
    var splitIndex = this.activeRoute.trackPoints().indexOf(splitPoint)

    var routeA = this.activeRoute.toSaveObj()
    routeA.pois = []
    routeA.course_points = _.filter(routeA.course_points, function(c) { return c.d <= splitPoint.distance})
    routeA.track_points = routeA.track_points.slice(0, splitIndex)
    delete routeA.id
    delete routeA.name

    var routeB = this.activeRoute.toSaveObj()
    routeB.track_points = routeB.track_points.slice(splitIndex)
    if (routeB.track_points.length > 0) {
      routeB.course_points = _.filter(routeB.course_points, function(c) { return c.d >= routeB.track_points[0].d})
    } else {
      routeB.course_points = []
    }
    delete routeB.id
    delete routeB.name

    // color is stored on the last tp in a segment, so in the likely case that
    // the split is in the middle of a segment, color for the new last segment
    // for routeA will lose its color value
    routeA.track_points[routeA.track_points.length - 1]['color'] = this.activeRoute.trackPoints()[routeA.track_points.length - 1].segment.color

    // Reset mileage indicators for the second part of the route
    if (routeB.track_points.length > 0) {
      var distanceOffset = routeB.track_points[0].d
      routeB.track_points.forEach((tp) => {
        tp.d = tp.d - distanceOffset
      })

      routeB.course_points.forEach((cp) => {
        cp.d = cp.d - distanceOffset
        cp.i = cp.i - splitIndex
      })
    }

    var route1 = this.loadRouteForEdit(routeA, true, false)
    var route2 = this.loadRouteForEdit(routeB, true, false)
    this.setActiveRoute(route1)

    var THREE_MILES = 4828.032  // This is 3 miles in meters
    wholeRoute.pois.forEach(function(poi) {
      var firstDistance = route1.distanceToLatLng(poi.googleLatLng(), this);
      var secondDistance = route2.distanceToLatLng(poi.googleLatLng(), this);

      if (firstDistance < secondDistance) {
        route1.pois.push(poi)
        if (secondDistance < THREE_MILES) {
          route2.pois.push(poi.copy())
        }
      } else {
        route2.pois.push(poi)
        if (firstDistance < THREE_MILES) {
          route1.pois.push(poi.copy())
        }
      }
    }, this);

    if (this.activeRoute.pois.length > 0) {
      this.loadPois(this.activeRoute.pois, false);
    }

    // Removing the active on should get rid of the one that split
    this.removeRoute(wholeRoute)

    this.drawRouteDistanceMarkers();
    this.loadElevationProfile();
    this.populateCuesheet(this.activeRoute.coursePoints());
    this.snapshot();
    rwgps.Events.trigger('map:routes_changed');
  },

  onRoutingSuccess: function(trackPoints, coursePoints, clickOptions, lineColor) {
    this.routingRequestInProgress = false;
    if(this.routingRequestCancelled) {
      this.routingRequestCancelled = false;
      return;
    }
    if(!this.opts.generateCues)
      coursePoints = null;
    var self = this;
    //make a function to save for later. call the function so the click
    //registers, but save it for potentially redoing after an undo
    var commitClick = function() {
      if(trackPoints.length <= 1) {
        // we need at least 2 track points to build the segment.
        // we only get one track point back when directions fail, for example a really short
        // attempt the wrong direction on a 1-way.
        // this happens in reverse route esp., so let's abort and call it done.
        rwgps.Events.trigger('map:routing_complete');
        return;
      }

      var prevCp;
      if(self.activeRoute.segments.length > 0) {
        var lastSeg = self.activeRoute.lastSegment,
          lastPt = lastSeg.nextControlPoint;
        prevCp = lastPt;

        let removingDupes = true
        do {
          const dist = lastPt.distanceFromPoint(trackPoints[0])
          // Graphhopper frequently doubles back on the path by less than 2 meters, which triggers spur detection
          // Consider these close enough to be duplicate points and just eliminate them.
          if (dist < 2) {
            trackPoints.shift()
          } else {
            removingDupes = false
          }
        } while (removingDupes && trackPoints.length > 0)
      } else {
        // this is the first segment, so pop off the first point from results and we'll make it our cp
        prevCp = trackPoints.shift();
      }
      // this is easier, we know the segment is getting appended so just make the last point the cp
      var nextCp = trackPoints.pop();

      var seg = new rwgps.Segment(self.activeRoute, prevCp, nextCp, trackPoints, coursePoints, lineColor);
      if(seg) {
        self.prevClick = seg.nextControlPoint.point;

        if(self.activeRoute.startMarker == null) {
          self.activeRoute.startMarker = new rwgps.StartIcon(seg.prevControlPoint.point, self);
        } else if(self.activeRoute.segments.length == 1) {
          // relocate start marker to first point of returned directions
          self.activeRoute.startMarker.gmarker.setPosition(seg.prevControlPoint.googleLatLng());
        }
        seg.clickOptions.setOptions(clickOptions.getOptions());
        // distances need to be in place for cuesheet and distance markers
        // need to get distances in place. if we had a "set distances only" method we could use it here
        self.activeRoute.calculateMetrics();
        // calculateMetrics just set all our grades to 0 erroneously, need them to be null for the fetchEle call below
        // to actually set grade properly
        _.each(trackPoints, function(tp) { tp.grade = null; });
        if(coursePoints && coursePoints.length > 0) {
          self.drawCoursePointIcons(coursePoints);
          self.populateCuesheet(coursePoints, true);
        }

        if(self.autoCenter) self.gmap.panTo(new google.maps.LatLng(self.prevClick.lat, self.prevClick.lng));


        const updatePlanner = () => {
          self.loadElevationProfile();
          self.activeRoute.flattenBridgesAndTunnels()
          self.relabel();
          // resetting grade on entire route so we get good numbers across segment boundaries.
          self.activeRoute.resetGrade();
          self.activeRoute.calculateMetrics();
          self.activeRoute.redrawPolylines();
          self.snapshot();
          rwgps.Events.trigger('map:routing_complete');

          self.drawSegmentDistanceMarkers(seg);
        }

        const tpWithoutEle = _.filter(trackPoints.concat([seg.prevControlPoint, seg.nextControlPoint]), tp => (tp.ele == undefined || tp.ele == null))
        if (tpWithoutEle.length > 0) {
          self.fetchElevations(tpWithoutEle, updatePlanner)
        } else {
          updatePlanner()
        }
      } else {
        //TODO: error
      }

      // let's detect if the person clicked an intersection
      // if a modal op is in progress (route reversal/out and back), don't do intersection click detection, these are
      // automated clicks
      if(!self.modalOperationInProgress && self.activeRoute.segments.length > 1) {
        rwgps.checkSpur(self.activeRoute.lastSegment.prevSegment)
      }
    };
    commitClick(); //actually do it

    //handle any other clicks in the queue
    this.dispatchNextClick();
  },

  relabel: function() {
    $(".txtDistance").text(rwgps.LabelMaker.longLabel(this.activeRoute.distance, "full"));
    $(".txtAscent").text(rwgps.LabelMaker.shortLabel(this.activeRoute.elevationGain()));
    $(".txtDescent").text(rwgps.LabelMaker.shortLabel(this.activeRoute.elevationLoss(), "full"));
  },

  onRoutingError: function(err) {
    this.routingRequestInProgress = false;
    if(this.routingRequestCancelled) {
      this.routingRequestCancelled = false;
      return;
    }
    trace(err)
    if(err == 'OVER_QUERY_LIMIT') {
      if(this.overQuota) {
        this.overQuota = false;
        rwgps.Events.trigger('map:routing_error');
        return false; // don't retry, reset.
      } else {
        var self = this;
        this.overQuota = true;
        setTimeout(function() {
          self.overQuota = false;
        }, 10000);
        return true; // retry
      }
    }
    rwgps.Events.trigger('map:routing_error');
    if(this.clickOptions.googleRouting() && this.clickOptions.cyclingMode()) {
      customAlert(T.t("no_routes_found_google_cycling"));
    } else {
      customAlert(T.t("no_routes_found"));
    }
    var tps = this.activeRoute.trackPoints();
    if(tps.length == 0) {
      const gll = this.activeRoute.startMarker.gmarker.position;
      this.prevClick = {lat: gll.lat(), lng: gll.lng()}
      return false;
    }
    this.prevClick = tps[tps.length-1].point;
    return false;
  },

  /* how is this linear search as fast/faster than kdtree?
  * implementation adapted from http://www.marsrutai.info/directions.htm
  */
  onMouseMove: function(event) {
    if(!this.throttledOnMouseMove) {
      this.throttledOnMouseMove = _.throttle($.proxy(this.nonthrottledOnMouseMove, this), 40);
      this.debouncedThrottledOnMouseMove = _.debounce(this.throttledOnMouseMove, 100);
    }
    this.throttledOnMouseMove(event);
    this.debouncedThrottledOnMouseMove(event);
  },

  findNearestPoint: function(googleLatLng) {
    if(this.activeRoute == null || this.activeRoute.segments.length == 0) return;
    var tps = this.activeRoute.trackPoints();

    // TODO: possibly erase getHighlightTrackPoints or whatever



    var mousePoint = this.googleLatLngToPoint(googleLatLng);
    var mouseX = mousePoint.x;
    var mouseY = mousePoint.y;
    this.nearestMousePoint1 = null;
    this.nearestMousePoint2 = null;
    this.nearestInterpolatedMousePoint = null
    if(!this.routePoints) { //repopulate cache
      this.routePoints = [];
      for(var j = 0; j < tps.length; j++) {
        if(tps[j].point) {
          var pt = this.googleLatLngToPoint(tps[j].googleLatLng());
          this.routePoints.push(pt.x);
          this.routePoints.push(pt.y);
          this.routePoints.push(tps[j]);
        } else {
          this.routePoints.push(null)
          this.routePoints.push(null)
          this.routePoints.push(null)
        }
      }
    }
    var minDist = 99999;
    var minX = this.routePoints[0];
    var minY = this.routePoints[1];
    var x = minX;
    var y = minY;
    var i, closestI, lowI, highI;
    var hasHighlighted = this.activeRoute.hasHighlightedSegment();
    for(i = 0; i < this.routePoints.length; i += 3) {
      var x0 = x;
      var y0 = y;
      x = this.routePoints[i];
      y = this.routePoints[i+1];

      if(x == null || y == null) continue;

      if((x < mouseX-50 && x0 < mouseX-50) || (x > mouseX+50 && x0 > mouseX+50))
        continue;
      if((y < mouseY-50 && y0 < mouseY-50) || (y > mouseY+50 && y0 > mouseY+50))
        continue;

      // If we are in 'Cue Review Mode', there is be a couple of highlighted segments on the route, and we should only interact with the highlighted segments
      if (hasHighlighted && this.routePoints[i+2] && (
        (this.routePoints[i+2].segment && this.routePoints[i+2].segment.drawInactive)  // If we're looking at a regular trackpoint with a segment that is highlighted
        || (!this.routePoints[i+2].segment && this.routePoints[i+2].prevSegment && !this.routePoints[i+2].prevSegment.drawInactive)  // if we are a controlpoint and the previous segment is highlighted
        || (!this.routePoints[i+2].segment && this.routePoints[i+2].nextSegment && !this.routePoints[i+2].nextSegment.drawInactive)  // if we are a control point and the next segment is highlighted
      )) {
        continue;
      }

      var dx = x - x0;
      var dy = y - y0;
      var d = dx*dx + dy*dy;

      var u = ((mouseX - x)*dx + (mouseY - y)*dy) / d;
      var x2 = x + (u*dx);
      var y2 = y + (u*dy);
      var dist = (mouseX - x2)*(mouseX - x2) + (mouseY - y2)*(mouseY - y2);
      if(dist < minDist) {
        var d1 = (mouseX - x0)*(mouseX - x0) + (mouseY - y0)*(mouseY - y0);
        var d2 = (mouseX - x)*(mouseX - x) + (mouseY - y)*(mouseY - y);
        if((d1 - dist) + (d2 - dist) > d) {
          if(d1 < d2) {
            dist = d1;
            x2 = x0;
            y2 = y0;
          } else {
            dist = d2;
            x2 = x;
            y2 = y;
          }
        }
      }

      if(dist < minDist) {
        minDist = dist;
        minX = x2;
        minY = y2;
        closestI = d1 < d2 ? i-1 : i+2;
        lowI = i - 1;
        highI = i + 2;
        this.nearestMousePoint = this.routePoints[closestI];
        this.nearestMousePointBehind = this.routePoints[lowI];
        this.nearestMousePointAhead = this.routePoints[highI];
      }
    }
    var nearestPoint = new google.maps.Point(minX, minY),
        closestTpsI = (closestI-2) / 3,
        lowTpsI = (lowI-2) / 3,
        highTpsI = (highI-2) / 3,
        high = tps[highTpsI],
        low = tps[lowTpsI];

    if(low && low.point) {
      const gll = this.pointToGoogleLatLng(nearestPoint);
      this.nearestInterpolatedMousePoint = {lat: gll.lat(), lng: gll.lng()}

      if(high == null || high.point == null || this.nearestInterpolatedMousePoint == null) return;

      var pct = low.distanceFromLatLng(this.nearestInterpolatedMousePoint) / high.distanceFromPoint(low);
      return {
        distance: minDist,
        point: nearestPoint,
        closestI: closestTpsI,
        lowI: lowTpsI,
        highI: highTpsI,
        pct: pct
      };
    }
  },

  nonthrottledOnMouseMove: function(event) {
    if(this.ignoreMouseMove) {
      return;
    }
    var nearest = this.lastNearestPoint = this.findNearestPoint(event.latLng);

    if(nearest && nearest.distance < 200) {
      // find nearest controlpoints and if too close abort! (don't perform this check if we're dragging)
      if(this.inPlanningMode()) {
        if(!this.draggingMarker) {
          var segToCheck = this.nearestMousePointBehind.segment || this.nearestMousePointBehind.nextSegment || this.nearestMousePointBehind.prevSegment;
          var nextCpPt = this.googleLatLngToPoint(segToCheck.nextControlPoint.googleLatLng());
          var prevCpPt = this.googleLatLngToPoint(segToCheck.prevControlPoint.googleLatLng());
          if( Math.pow(nearest.point.x-nextCpPt.x, 2) + Math.pow(nearest.point.y-nextCpPt.y, 2) < 150 || Math.pow(nearest.point.x-prevCpPt.x, 2) + Math.pow(nearest.point.y-prevCpPt.y, 2) < 150 ) {
            if(this.nearestPointMarker && this.nearestPointMarker.gmarker.getMap()) {
              this.unhighlightNearestPoint();
            }
            return; // abort! too close!
          }
        }
      }
      this.showNearestPointMarkerAt(this.nearestInterpolatedMousePoint);
      //trace(this.nearestInterpolatedMousePoint + "");
      // if there are highlighted points, the flash standalone histo is broke when trying to highlight a point so dont bother trying
      if(this.eleProfile()) {
        var tps = this.activeRoute.trackPoints();
        this.updatePlayhead(tps[nearest.closestTpsI], tps);
        rwgps.Events.trigger('map:highlight_point', nearest);
      }
    } else if(this.nearestPointMarker && this.nearestPointMarker.gmarker.getMap()) {
      this.unhighlightNearestPoint();
    }
  },

  showNearestPointMarkerAt: function(latLng) {
    if(this.nearestPointMarker == null) {
      this.nearestPointMarker = new rwgps.NearestPointIcon(latLng, this);
      google.maps.event.addListener(this.nearestPointMarker.gmarker, "click", $.proxy(this.onNearestPointMarkerClicked, this));
    }

    if(this.nearestPointMarker.gmarker.getMap() == null) this.nearestPointMarker.gmarker.setMap(this.gmap);
    if(this.nearestPointMarker.gmarker.getVisible() == false) this.nearestPointMarker.gmarker.setVisible(true);
    this.nearestPointMarker.gmarker.setPosition(new google.maps.LatLng(latLng.lat, latLng.lng));
    this.nearestPointMarker.gmarker.setZIndex(0); //hack, setPosition seems to reset zindex to top :(
  },

  unhighlightNearestPoint: function() {
    if(!this._playing && !this._paused && this.nearestPointMarker && this.nearestPointMarker.gmarker.getVisible()) {
      this.nearestPointMarker.gmarker.setVisible(false);
      rwgps.Events.trigger('map:unhighlight_nearest_point');
      // set playback to 0 if its there
      if($.ui && $.ui.slider && $("#elapsed_time_slider").data("ui-slider")) {
        $("#elapsed_time_slider").slider('option', 'value', 0);
        $('#elapsed_time').html( '00:00:00' );
      }
    }
  },

  eleProfile: function() {
    const divId = this.opts.eleProfileId || 'elevation_profile'
    return document.getElementById(divId);
  },

  mapTypeChanged: function() {
    var mapType = this.gmap.getMapTypeId();
    //TODO: decouple this...
    //TODO: move rwgps click options over to the new planner options generic
    //class...then setup ids for giRouting, etc, so this shit can just turn
    //into a single call
    if(mapType == "osmCycle" || mapType == "osm") {
      this.clickOptions.osmRouting(true);
    } else if(mapType == "esriTopo") {
      this.clickOptions.arcgisRouting(true);
    } else { //google or usgsTopo maps
      this.clickOptions.googleRouting(true);
    }
    //mapTypeChanged is only triggered when basemaps changes from upper right
    //maptype selection, and we can only have one basemap at a time, which is
    //the bottom most active overlay
    this.activeOverlays[0] = this.overlays[mapType];
    if(this.inPlanningMode()) {
      Application.setPreference("planner_overlay", mapType, true);
    }
    this.onOverlayChanged();
  },

  onMapZoom: function() {
    this.routePoints = null; //blow cache for mousing near route
    //this.drawGrid();
  },
  onMapDragStart: function() {},
  onMapDragEnd: function() {
    this.routePoints = null; //blow cache for mousing near route
  },

  revert: function() {
    rwgps.actionsManager.revert();
  },
  undo: function() {
    trackEvent('Route Planner', 'Route Ops', 'Undo');
    this.zoomOut();
    if(rwgps.actionsManager.canUndo()) {
      rwgps.actionsManager.undo();
    } else {
      // if we're out of stuff to undo, revert to old behavior of
      // lopping off segments
      this.undoLastClick();
      this.snapshot({manualUndo: true});
    }
  },
  redo: function() {
    trackEvent('Route Planner', 'Route Ops', 'Redo');
    this.zoomOut();
    rwgps.actionsManager.redo();
  },

  zoomOut: function() {
    if(Routes.sampleGraph) {
      Routes.sampleGraph.zoomOut();
      if(Routes.sampleGraph.segmentSelector)
        Routes.sampleGraph.segmentSelector.unload();
    }
  },

  clearSegment: function() {
    if (Routes.sampleGraph) {
        if (Routes.sampleGraph.segmentSelector)
          Routes.sampleGraph.segmentSelector.unload();
    }
  },

  undoLastClick: function() {
    if(this.activeRoute.segments.length === 0) {
      if(this.activeRoute.startMarker) {
        // alright kill the start marker and really clear map
        this.clearAllOverlays();
        this.prevClick = null;
        this.routes.slice(_.indexOf(this.routes, this.activeRoute), 1);
        this.setActiveRoute(new rwgps.Route(null, this));
        this.routes.push(this.activeRoute);
      }
    } else  {
      var segment = this.activeRoute.segments[this.activeRoute.segments.length-1];
      this.removeSegmentDistanceMarkers(segment);
      this.activeRoute.removeSegment(segment);
      this.prevClick = segment.prevControlPoint.point;
    }

    if(this.nearestPointMarker) {
      this.unhighlightNearestPoint();
    }

    rwgps.Events.trigger("cp:populate", this.activeRoute.coursePoints(), false);
    this.routePoints = null;
    this.loadElevationProfile();
    this.updateDistanceMarkersDisplayed();
  },

  //TODO: this doesn't remove references to markers from coursepoints...
  //TODO: this method lies - it doesn't clear ephemerel POI either...
  //not sure if that should be handleded here or what.
  clearAllOverlays: function() {
    this.closeStickyInfoWindow();
    this.closePreviewInfoWindow();
    var i = 0;
    for(i = 0; i < this.routes.length; i++) {
      this.routes[i].clearAllOverlays();
    }
    if(this.pointsOfInterest) {
      for(i = 0; i < this.pointsOfInterest.length; i++) {
        this.pointsOfInterest[i].marker.gmarker.setMap(null);
      }
      this.poiGBounds = null
    }
    if(this.nearestPointMarker) {
      this.unhighlightNearestPoint();
    }
  },

  clearMapWithConfirm: function() {
    trackEvent('Route Planner', 'Route Ops', 'Clear map');
    var that = this;
    customConfirm(T.t("clear_map_confirm"), function() {
      that.clearMap();
      rwgps.actionsManager.clear();
      that.snapshot();
    });
  },
  clearMapWithHistory: function() {
    this.clearMap();
    rwgps.actionsManager.clear();
    this.snapshot();
  },
  addRoute: function(route, setActive) {
    this.routes.push(route);
    if(setActive) {
      this.setActiveRoute(route);
    } else {
      route.redraw();
    }
    rwgps.Events.trigger('map:routes_changed');
  },
  removeRoute: function(route, useNextRoute) {
    if(this.activeRoute === route)
      this.zoomOut();
    route.clearAllOverlays();
    this.removeRouteDistanceMarkers(route);
    this.routes.splice(_.indexOf(this.routes, route), 1);
    if(this.activeRoute === route) {
      this.zoomOut();
      // clear routepoints cache
      delete this.routePoints;
      this.activeRoute = null;
      if(useNextRoute && this.routes.length > 0) {
        this.setActiveRoute(this.routes[0]);
      } else {
        this.setActiveRoute(new rwgps.Route(null, this));
      }
    } else {
      rwgps.Events.trigger('map:routes_changed', this);
      this.snapshot();
    }
  },
  redrawRoutes: function() {
    _.each(this.routes, function(route) {
      route.redraw();
    });
  },
  //for planning, clearing should completely wipe everything out
  clearMap: function() {
    this.zoomOut();
    this.clearAllOverlays();
    this.removeRouteDistanceMarkers(this.activeRoute);

    delete this.pointsOfInterest;
    this.pointsOfInterest = [];
    this.routes = [];
    this.activeRoute = null;
    this.setActiveRoute(new rwgps.Route(null, this));
    this.prevClick = null;
    this.activeRoute.calculateMetrics();
    this.closePreviewInfoWindow();
    this.closeStickyInfoWindow();

    if (Routes.sampleGraph)
    {
        Routes.sampleGraph.data([]);
    }

    //clear auto-saved route
    if(this.mode == "plan") $.jStorage.deleteKey("locallySavedRoute");
  },

  reverseRoute: function() {
    trackEvent('Route Planner', 'Route Ops', 'Reverse');
    this.replayRouteInReverse(true);
  },
  outAndBack: function() {
    trackEvent('Route Planner', 'Route Ops', 'Out and back');
    this.replayRouteInReverse(false);
  },
  replayRouteInReverse: function(replaceRoute) {
    this.zoomOut();
    if(this.opts.tripId) {
      rwgps.Events.trigger("trip:modification_prevented");
      return;
    }
    this.snapshot({updateLast: true, doSync: true});
    if(this.activeRoute.firstSegment) {
      var segs = this.activeRoute.segments;
      var lastSeg = segs[segs.length-1];
      var newSegmentClicks = replaceRoute ? [{
        point: lastSeg.nextControlPoint.point,
        opts: lastSeg.clickOptions,
        color: lastSeg.color,
        fetchEles: true
      }] : [];
      var delay = 0;
      for(var i=segs.length-1; i >= 0; --i) {
        var seg = segs[i];
        if(segs.length-i == 6) {
          delay = 1000;
        }
        var click = {
          point: seg.prevControlPoint.point,
          opts: seg.clickOptions,
          color: seg.color,
          fetchEles: true,
          delay: delay
        };
        // if we don't expect any course points, we can just reverse the points in the segment
        // this allows for recorded data to be properly reversed.
        // we need points without distance set though, and metrics calculator will set them properly.
        if(seg.coursePoints.length === 0) {
          click.points = _.map(seg.trackPoints, function(pt) {
            return pt.shallowClone();
          }).reverse();
        }
        newSegmentClicks.push(click);
      }

      if(replaceRoute) {
        // figure out where the route was in order
        var idx = _.indexOf(this.routes, this.activeRoute);
        // remove route, which creates a new one and pushes to end of list.
        var rData = this.activeRoute.routeData;
        var pois = this.activeRoute.pois
        this.removeRoute(this.activeRoute);
        // so pop it off and stick it in the right place
        var r = this.routes.pop();
        r.routeData = rData; // retain route name and other metadata
        r.pois = pois;
        this.routes.splice(idx, 0, r);
        this.loadPois(r.pois);
        rwgps.Events.trigger('map:routes_changed');
      }
      _.each(newSegmentClicks, function(clickAttrs) {
        this.clicks.push(clickAttrs);
      }, this);
      var onRoutingError, onRoutingComplete, forceCancel, unbindHandlers,
          totalRoutingOps = _.reduce(newSegmentClicks, function(acc, click) {
            return acc + (click.opts.followRoads() ? 1 : 0);
          }, 0),
          totalClickOps = newSegmentClicks.length - (replaceRoute ? 1 : 0),
          clickOpsComplete=0,
          useModal = totalRoutingOps > 4;

      unbindHandlers = function() {
        rwgps.Events.unbind('map:routing_error', onRoutingError);
        rwgps.Events.unbind('map:routing_complete', onRoutingComplete);
        rwgps.Events.unbind('map:modal_operation_cancelled', forceCancel);
      };
      forceCancel = _.bind(function() {
        unbindHandlers();
        this.clicks = [];
        if(this.routingRequestInProgress) {
          this.routingRequestCancelled = true;
        }
        this.snapshotsDisabled = false;
        this.revert();
      }, this);
      onRoutingComplete = _.bind(function() {
        clickOpsComplete++;
        if(useModal)
          rwgps.Events.trigger('map:modal_operation_progress', clickOpsComplete, totalClickOps);
        if(clickOpsComplete == totalClickOps) {
          unbindHandlers();
          if(useModal) {
            rwgps.Events.trigger('map:modal_operation_complete');
            this.modalOperationInProgress = false;
          }
          this.snapshotsDisabled = false;
          this.snapshot();
        }
      }, this);
      onRoutingError = _.bind(function() {
        unbindHandlers();
        this.clicks = [];
        this.snapshotsDisabled = false;
        rwgps.Events.trigger('map:reverted_due_to_error');
        this.revert();
      }, this);
      this.snapshotsDisabled = true;
      rwgps.Events.bind('map:routing_complete', onRoutingComplete);
      rwgps.Events.bind('map:routing_error', onRoutingError);
      rwgps.Events.bind('map:modal_operation_cancelled', forceCancel);
      if(useModal) {
        this.modalOperationInProgress = true;
        rwgps.Events.trigger('map:modal_operation_started');
      }
      this.dispatchNextClick();
    }
  },

  removeAllNonActiveRoutes: function() {
    //TODO: this doesn't take into account partial route segments on the map...should preview
    //routes be in a separate collection than just the map routes array?
    _.map(this.routes, function(rt) {
      if(rt != this.activeRoute) rt.removeFromMap();
    });
    if(this.previewInfoWindow) this.previewInfoWindow.close();
    if(this.stickyInfoWindow) this.stickyInfoWindow.close();
  },

  loadRoute: function(route, drawEndMarker) {
    var drawEnd = (drawEndMarker === undefined ? true : drawEndMarker == true);
    var seg = route.segments[0], i = 0;
    route.map = this;

    if(route.segments.length > 0) {
      var pt = seg.prevControlPoint.point;
      if(!pt) {
        // it's a trip without location on the first n points, try to find a point w/ location
        for(i=0; i < seg.trackPoints.length; i++) {
          if(seg.trackPoints[i].point) {
            pt = seg.trackPoints[i].point;
            break;
          }
        }
      }
      route.startMarker = new rwgps.StartIcon(pt, this);
      seg = route.segments[route.segments.length-1];
      if(drawEnd)
        route.endMarker = new rwgps.EndIcon(seg.nextControlPoint.point, this);
      for(i = 0; i < route.segments.length; i++) {
        route.segments[i].addToMap(this);
      }
    }

    this.routes.push(route);
  },

  loadRouteForEdit: function(routeObj, leaveViewportAlone, initialLoad) {
    //this.clearAllOverlays();
    var route, tps;
    if(routeObj.track_points) {
      route = new rwgps.Route(routeObj, this, {planning: true});
      this.loadRoute(route, false);
    } else if(_.isFunction(routeObj.trackPoints)) {
      route = routeObj;
      this.loadRoute(route, false);
    } else if(routeObj.start_point) {
      route = new rwgps.Route(null, this);
      this.prevClick = {lat: routeObj.start_point.y, lng: routeObj.start_point.x}
      this.setActiveRoute(route);
      this.activeRoute.startMarker = new rwgps.StartIcon(this.prevClick, this);
    } else {
      route = new rwgps.Route(null, this);
    }

    tps = route.trackPoints();
    if(tps.length > 0) {
      this.prevClick = tps[tps.length-1].point;
    }

    this.setActiveRoute(route);
    rwgps.Events.trigger('pois:populate', this.activePointsOfInterest());
    route.drawControlPoints(this);

    if (!leaveViewportAlone) {
      this.recenterMap()
    }

    if(initialLoad) this.snapshot();

    return route;
  },

  loadRouteForView: function(route, afterEleCb) {
    this.clearAllOverlays(); //TODO: should I call this? or make it an option?
    this.loadRoute(route, true);
    this.gmap.fitBounds(route.gBounds);

    //rethink this...loading route doesn't always mean we want to make it active and load its cuesheet
    this.setActiveRoute(route);

    if(afterEleCb) this.afterLoadElevationProfileFn = afterEleCb;
  },
  loadPois: function(raw, readOnly) {
    //pois being loaded for editing (editing a route) need to be flagged.
    if(readOnly === undefined) readOnly = true;
    if(this.pointsOfInterest) {
      _.each(this.pointsOfInterest, function(poi) {
        poi.marker.gmarker.setMap(null);
      });
    }

    // if we're handed instantiated poi, just use the reference, otherwise instantiate
    // this is important to ensure route planner poi editing doesn't revert changes due
    // to having multiple copies of a poi (between route.pois and map.pointsOfInterest)
    var pois = _.map(raw, function(poi) {
      if (_.isFunction(poi.toSaveObj)) {
        return poi;
      } else {
        return rwgps.PointOfInterest.fromJSON([poi], readOnly)[0];
      }
    });

    this.pointsOfInterest = pois;
    this.poiGBounds = new google.maps.LatLngBounds();
    var self = this;
    _.each(this.pointsOfInterest, function(poi) {
      self.poisById[poi.id] = poi;
      poi.marker = new rwgps.PoiIcon(poi, self);
      self.poiGBounds.extend(poi.googleLatLng());
    });
    if (!this.opts.poiEnabled) {
      pois.forEach(({ marker: { gmarker } }) => gmarker.setMap(null))
    }
  },

  // the below POI editing/viewing functions are copied and modified from coursepoint
  // functions doing similar things. if you refactor this, make sure to refactor coursepoint stuff too
  openPreviewInfoWindow: function(poi, pan) {
    pan = (pan == undefined? true : pan);
    if(this.previewInfoWindow) {
      this.previewInfoWindow.close();
      this.previewInfoWindow = null;
    }
    this.previewInfoWindow = new InfoBox({
      position: poi.googleLatLng(),
      content: this.contentForPoiInfoWindow(poi, true),
      disableAutoPan: !pan,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-140, -40),
      alignBottom: true,
      zIndex: null,
      closeBoxURL: "",
      boxStyle: {
        opacity: 0.90,
        minWidth: "200px",
        maxWidth: "260px",
        padding: "10px",
        border: "1px solid black",
        background: "white"
      },
      closeBoxMargin: "2px 2px 2px 2px",
      infoBoxClearance: new google.maps.Size(1, 1),
      isHidden: false,
      pane: "floatPane",
      enableEventPropagation: false
    });
    google.maps.event.addListener(this.previewInfoWindow, "closeclick", $.proxy(this.closePreviewInfoWindow, this));
    google.maps.event.clearListeners(this.previewInfoWindow, "domready");
    google.maps.event.addListener(this.previewInfoWindow, "domready", $.proxy(function() {
      this.initInfoWindowHandlers();
    }, this));
    this.disableClicks(); // disable map interaction while infowindow is open
    this.previewInfoWindow.open(this.gmap);//, (poi.marker ? poi.marker.gmarker : null));
  },
  openStickyInfoWindow: function(poi, pan) {
    if(this.openPoi && this.openPoi.marker) this.openPoi.marker.enableMouseOverOut();
    if(poi.marker) poi.marker.disableMouseOverOut();

    this.openGenericStickyInfoWindow(poi.point, this.contentForPoiInfoWindow(poi), pan);

    google.maps.event.addListener(this.stickyInfoWindow, "domready", $.proxy(function() {
      tb_init("a.thickbox");
      this.initPoiInfoWindowHandlers(poi);
      this.initPointPhotoWidget(poi);
    }, this));

    this.openPoi = poi;
  },
  openGenericStickyInfoWindow: function(point, content, pan) {
    pan = (pan == undefined? true : pan);
    this.closePreviewInfoWindow(); //close any preview windows open from mouseover
    if(this.stickyInfoWindow) {
      this.stickyInfoWindow.close();
      this.stickyInfoWindow = null;
    }
    this.stickyInfoWindow = new InfoBox({
      position: new google.maps.LatLng(point.lat, point.lng),
      content: content,
      disableAutoPan: !pan,
      maxWidth: 0,
      pixelOffset: new google.maps.Size(-140, -40),
      alignBottom: true,
      zIndex: null,
      boxStyle: {
        opacity: 1.0,
        zIndex: 1000,
        minWidth: "240px",
        maxWidth: "400px",
        overflow: "auto",
        maxHeight: "500px",
        padding: "20px",
        background: '#FFFFFF',
        border: '1px solid #E8E8E8',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.20)'
      },
      closeBoxMargin: "2px 2px 2px 2px",
      infoBoxClearance: new google.maps.Size(10, 10),
      isHidden: false,
      pane: "floatPane",
      enableEventPropagation: false
    });
    google.maps.event.addListener(this.stickyInfoWindow, "closeclick", $.proxy(this.closeStickyInfoWindow, this));
    google.maps.event.clearListeners(this.stickyInfoWindow, "domready");
    google.maps.event.addListener(this.stickyInfoWindow, "domready", $.proxy(function() {
      this.initInfoWindowHandlers();
    }, this));
    this.disableClicks(); // disable map interaction while infowindow is open
    this.stickyInfoWindow.open(this.gmap);
  },
  //TODO: this doesn't belong in map.js
  initPointPhotoWidget: function(point) {
    if(!point || !window.rwgpsG_views_photos) return;

    var photos = _.map(point.photoIds, function(id) { return {id: id}; });
    var PhotosView = rwgpsG_views_photos;
    if(!PhotosView) return;
    var photosView = new PhotosView({
      container: '#poiInfoWindowContent .photos_view, #coursePointInfoWindowContent .photos_view',
      photos: photos,
      canEdit: true,
      photosetDisabled: true
    });

    photosView.bind('photo:added', function(photo) {
      point.photoIds.push(photo.id);
    });
    photosView.bind('photo:deleted', function(photo) {
      point.photoIds = _.without(point.photoIds, photo.id);
    });
  },
  initPoiInfoWindowHandlers: function(poi) {
    if(this.inPlanningMode() && poi.isEditable()) {
      $('#poiInfoWindowContent select.poiType').msDropDown();
    }
  },
  contentForPoiInfoWindow: function(poi, preview) {
    if(preview == undefined) preview = false;
    if(this.inPlanningMode() && poi.isEditable() && rwgps.config.privileges['advanced_planning']) {
      return poi.editHtml();
    } else { //just show it
      if(preview) return poi.previewHtml();
      return poi.showHtml();
    }
  },
  deletePoi: function(poi) {
    poi = poi || this.openPoi;
    if(!poi) return;

    poi.marker.gmarker.setMap(null); // remove from the map
    this.pointsOfInterest.splice(_.indexOf(this.pointsOfInterest, poi), 1);
    this.activeRoute.pois.splice(_.indexOf(this.activeRoute.pois, poi), 1);
    if(poi.id) {
      delete this.poisById[poi.id]
      rwgps.Events.trigger("pois:deleted", [poi])
    }

    this.closePreviewInfoWindow();
    this.closeStickyInfoWindow();
    this.snapshot();

    rwgps.Events.trigger("pois:populate", this.activePointsOfInterest());
  },
  closeStickyInfoWindow: function() {
    if(this.openPoi) {
      if(this.openPoi.marker) this.openPoi.marker.enableMouseOverOut();

      if(this.openPoi._new) {
        var poi = this.openPoi;
        poi.marker.gmarker.setMap(null); // remove from the map
        var idx = _.indexOf(this.pointsOfInterest, poi);
        this.pointsOfInterest.splice(idx, 1);
        if(poi.id) delete this.poisById[poi.id]
        rwgps.Events.trigger("pois:populate", this.activePointsOfInterest());
      }
      this.openPoi = null;
    }
    if(this.stickyInfoWindow) this.stickyInfoWindow.close();
    this.enableClicks(); //re-enable map interaction since infowindow is closed...
  },
  closePreviewInfoWindow: function() {
    this.openPoi = null;
    if(this.previewInfoWindow) this.previewInfoWindow.close();
    this.enableClicks(); //re-enable map interaction since infowindow is closed...
  },
  savePoi: function(poi) {
    poi = poi || this.openPoi;
    if(!poi) return;
    if(poi._new) delete poi._new;
    this.poisById[poi.id] = poi;
    poi.poiType = $("#poiInfoWindowContent select.poiType").val();
    poi.name = $("#poiInfoWindowContent .poiName").val();
    poi.description = $("#poiInfoWindowContent textarea.poiDescription").val();
    poi.attribution = $("#poiInfoWindowContent .poiAttribution").val();
    poi.url = $("#poiInfoWindowContent .poiUrl").val();
    poi.addToPoiLibrary = $("#poiInfoWindowContent .addToPoiLibrary").prop("checked");
    poi.saveOrUpdate = $("#poiInfoWindowContent input:radio[name='saveOrUpdate']:checked").val()
    if(poi.marker) poi.marker.gmarker.setMap(null);
    poi.marker = new rwgps.PoiIcon(poi, this);

    this.closeStickyInfoWindow();
    rwgps.Events.trigger('pois:populate', this.activePointsOfInterest());
    this.snapshot();
  },
  // pois excluding ghosted ones
  activePointsOfInterest: function() {
    return _.select(this.pointsOfInterest, function(poi) { return !poi.ghosted; });
  },
  pointsOfInterestObjs: function() {
    return _.map(this.pointsOfInterest, function (poi) {
      return poi.toSaveObj();
    });
  },

  gotoLatLng: function(lat, lng, showMarker) {
    return this.gotoPoint({lat, lng}, showMarker);
  },
  gotoPoint: function(point, showMarker) {
    if(isNaN(point.lat) || isNaN(point.lng)) return;
    const googleLatLng = new google.maps.LatLng(point.lat, point.lng)
    this.gmap.setCenter(googleLatLng);
    if(showMarker) {
      var opts = {
        position: googleLatLng,
        clickable: true
      }
      if (this._gotoMarker) this._gotoMarker.setMap(null)
      var marker = new google.maps.Marker(opts);
      this._gotoMarker = marker
      var self = this;
      var clickFn = () => {
        var content = '<div style="height:60px;margin-top:15px;text-align:center;padding-top:10px">' +
          `<div style='display:flex;justify-content:space-around'><a href="javascript:;" class="route_to_point btn btn-primary">${!self.prevClick ? 'Start route here' : 'Route to here'}</a>` +
          '<a href="javascript:;" class="remove_marker btn btn-secondary" style="border:1px solid #f60;margin-left:10px">Remove marker</a></div>' +
          '</div>';
        self.openGenericStickyInfoWindow(point, content, true);
        google.maps.event.addListener(self.stickyInfoWindow, "domready", () => {
          $(".route_to_point").click(() => {
            rwgps.Events.trigger("map:route_to_point", point);
            if (this._gotoMarker) this._gotoMarker.setMap(null)
            return false;
          });
          $(".remove_marker").click(() => {
            Routes.activeMap.closeStickyInfoWindow();
            if (this._gotoMarker) this._gotoMarker.setMap(null)
            return false;
          });
        });
      }
      google.maps.event.addListener(marker, 'click', clickFn);
      marker.setMap(this.gmap);
      setTimeout(clickFn, 0);
      return marker;
    }
  },

  gotoLocation: function(str, showMarker) {
    var self = this;
    // just realized we arent using jquery 1.5 so doing this manually
    // instead of using $.Deferred
    var dfd = new function() {
      var self = this;
      this.done = function(fn) { self.doneCb = fn; return this; }
      this.fail = function(fn) { self.failCb = fn; return this; }
      this.resolve = function() { self.doneCb.apply(self, arguments); }
    }
    // first try our cache from /places/search autocompleter
    var latLngMatch = str.match(/^[ ]*(-?[0-9]+\.[0-9]+)[ ]*,?[ ]*(-?[0-9]+\.[0-9]+)[ ]*$/),
      marker;
    if(rwgps.places[str]) {
      marker = this.gotoLatLng(rwgps.places[str].y, rwgps.places[str].x, showMarker);
      return {done: function(fn) { fn.call(self, marker) }}
    } else if(latLngMatch) {
      marker = this.gotoLatLng(latLngMatch[1], latLngMatch[2], showMarker);
      _.defer(() => { dfd.resolve(marker) }) // needs to happen async so the doneCb can get assigned first.
      return dfd
    }
    var gc = new google.maps.Geocoder();
    var opts = {
      address: str,
      location: this.gmap.getCenter(),
      bounds: this.gmap.getBounds(),
      language: this.language, //set on map initialization
      region: this.region //set on map initialization
    };
    gc.geocode(opts, function(results, status) {
      if(status == google.maps.GeocoderStatus.OK) {
        //TODO: iterate through results and find best?
        //not sure if they are returned in order of accuracy
        if(results.length > 0 && results[0].geometry) {
          const gll = results[0].geometry.location
          dfd.resolve(self.gotoPoint({lat: gll.lat(), lng: gll.lng()}, showMarker));
        } else {
          dfd.failCb();
        }
      } else {
        dfd.failCb();
      }
    });
    return dfd;
  },

  geocode: function(addr, success, error) {
    var self = this;
    var gc = new google.maps.Geocoder();
    var opts = {
      address: addr,
      location: this.gmap.getCenter(),
      bounds: this.gmap.getBounds(),
      language: this.language, //set on map initialization
      region: this.region //set on map initialization
    };
    gc.geocode(opts, function(results, status) { self.geocodingResponse(results, status, success, error) });
  },
  reverseGeocode: function(latLng, success, error) {
    var self = this;
    var gc = new google.maps.Geocoder();
    var opts = {
      latLng: latLng,
      language: this.language, //set on map initialization
      region: this.region //set on map initialization
    };
    gc.geocode(opts, function(results, status) { self.geocodingResponse(results, status, success, error) });
  },
  geocodingResponse: function(results, status, success, error) {
    if(status == google.maps.GeocoderStatus.OK) {
      var location = {};
      var aa2, aa3; //if no first level AA, we might default to lower level ones (county)
      //first result is the most specific
      if(results.length > 0 && results[0].address_components) {
        if(results[0].geometry && results[0].geometry.location) {
          location["lat"] = results[0].geometry.location.lat();
          location["lng"] = results[0].geometry.location.lng();
        }
        _.each(results[0].address_components, function(com) {
          _.each(com.types, function(type) {
            if(type == "country") location["country_code"] = com.short_name;
            if(type == "administrative_area_level_1") location["administrative_area"] = com.long_name;
            if(type == "locality") location["locality"] = com.long_name;
            if(type == "postal_code") location["postal_code"] = com.long_name;
            if(type == "administrative_area_level_2") aa2 = com.long_name;
            if(type == "administrative_area_level_3") aa3 = com.long_name;
          });
        });
        if(!location["administrative_area"]) {
          if(aa2) location["administrative_area"] = aa2;
          else location["administrative_area"] = aa3;
        }
        success(location);
      } else {
        //TODO: no results
        success({});
      }
    } else if(status === 'ZERO_RESULTS') {
      // no results, nothing to assign but no need to throw error
      success({});
    } else {
      error(status);
    }
  },

  drawCoursePointIcons: function(points) {
    var self = this,
        showAll = this.showCoursePointIcons;
    if(showAll || this.inPlanningMode()) {
      _.map(points, function(pt) {
        if(showAll) {
          if(pt.marker) {
            pt.marker.gmarker.setMap(self.gmap);
          } else {
            var marker = new rwgps.CoursePointIcon(pt, self);
            pt.marker = marker;
          }
        }
      });
    }
  },
  removeCoursePointIcons: function(points) {
    _.map(points, function(pt) {
      if(pt.marker && pt.marker.gmarker) pt.marker.gmarker.setMap(null); });
  },

  populateCuesheet: function(points, append) {
    if(append === undefined) append = false;
    rwgps.Events.trigger("cp:populate", points, append);
  },

  resize: function() {
    if(this.activeRoute || this.staticBounds) {
      google.maps.event.trigger(this.gmap, 'resize');
      var bounds = this.inclusiveBounds();
      if(!bounds.isEmpty())
        this.gmap.fitBounds(bounds);
    }
  },

  setColor: function(color, suppressEvent) {
    //color is either a hex string or an int...handle both!
    this.lineColor = parseInt(color);
    if(!suppressEvent)
      rwgps.Events.trigger("map:colorChanged", rwgps.Segment.cssColor(this.lineColor));
  },

  showCoursePointMarker: function(cp) {
    this.coursePointPopup.setCoursePoint(cp);
    this.coursePointPopup.show();
  },
  hideCoursePointMarker: function() {
    this.coursePointPopup.hide();
  },

  //swap the draw route click handler for the add
  //coursepoint click handler
  enableAddCoursePoint: function() {
    this.addCoursePointEnabled = true;
    this.disableClicks();
    if(Routes.sampleGraph) {
      Routes.sampleGraph.bind('pointselected', this.addCoursePointAtIndex);
    }
  },
  disableAddCoursePoint: function() {
    this.addCoursePointEnabled = false;
    this.enableClicks();
    if(Routes.sampleGraph) {
      Routes.sampleGraph.unbind('pointselected', this.addCoursePointAtIndex);
    }
  },
  addControlPointAtIndex: function(pointsAround) {
    var pt = this.activeRoute.trackPoints()[pointsAround.closestI];
    if (!pt.isControlPoint) {
      var segmentI = _.indexOf(pt.segment.trackPoints, pt);
      pt.segment.splitAfter(segmentI);
    }
  },
  addCoursePointAtIndex: function(pointsAround) {
    var pt = this.activeRoute.trackPoints()[pointsAround.closestI];
    this.openCoursePointInfoWindow(new rwgps.CoursePoint({
      point: pt.point,
      trackPoint: pt,
      segment: pt.segment,
      distance: pt.distance
    }));
  },
  enableAddControlPoint: function() {
    this.addControlPointEnabled = true;
    this.disableClicks();
    if(Routes.sampleGraph) {
      Routes.sampleGraph.bind('pointselected', this.addControlPointAtIndex);
    }
    rwgps.Events.bind('map:control_point_clicked', this.onControlPointClickRemove);
  },
  onControlPointClickRemove: function(cp) {
    // removing control points has a different behavior in cue review mode
    if (
      (cp.trackPoint.nextSegment && cp.trackPoint.prevSegment) && (
        (cp.trackPoint.prevSegment.drawInactive === true && cp.trackPoint.nextSegment.drawInactive === false)
        || (cp.trackPoint.prevSegment.drawInactive === false && cp.trackPoint.nextSegment.drawInactive === true)
      )
    ) {
      return;
    }

    const seg = cp.trackPoint.prevSegment;
    seg.slurpNext();
    // slurpNext removes course point icons and mile markers
    cp.map.drawCoursePointIcons(seg.coursePoints);
    cp.map.drawRouteDistanceMarkers(cp.map.activeRoute);
    cp.map.snapshot({updateLast: true});
  },
  disableAddControlPoint: function() {
    this.addControlPointEnabled = false;
    this.enableClicks();
    if(Routes.sampleGraph) {
      Routes.sampleGraph.unbind('pointselected', this.addControlPointAtIndex);
    }
    rwgps.Events.unbind('map:control_point_clicked', this.onControlPointClickRemove)

  },

  enableRouteSplitter: function () {
    this.routeSplitterEnabled = true;
    this.disableClicks();
    if (Routes.sampleGraph) {
      Routes.sampleGraph.bind('pointselected', this.splitRouteAtIndex, this);
    }
  },
  disableRouteSplitter: function () {
    this.routeSplitterEnabled = false;
    this.enableClicks();
    if (Routes.sampleGraph) {
      Routes.sampleGraph.unbind('pointselected', this.splitRouteAtIndex);
    }
  },
  splitRouteAtIndex: function (pointsAround) {
    this.addControlPointAtIndex(pointsAround);
    var pt = this.activeRoute.trackPoints()[pointsAround.closestI];

    return this.splitRouteOnTrackPoint({trackPoint: pt, idx: pointsAround.closestI});
  },

  openCoursePointInfoWindow: function(cp, sticky) {
    if(sticky === undefined) sticky = true;
    var window, pan;

    if(sticky) {
      pan = true;
    } else {
      // stickyInfoWindow doesn't get nulled out on close, but the dom element goes away
      // it does get nulled out when a preview window is shown on hover though
      if (this.stickyInfoWindow && $('#coursePointInfoWindowContent').get(0)) {
        // no previews when a stick window is open, user must close first
        return
      }
      pan = false;
    }

    if (this.stickyInfoWindow) this.stickyInfoWindow.close()
    if (this.previewInfoWindow) this.previewInfoWindow.close()

    window = new google.maps.InfoWindow({
      position: cp.googleLatLng(),
      maxWidth: 220,
      disableAutoPan: !pan,
      content: this.contentForCoursePointInfoWindow(cp)
    });
    google.maps.event.addListener(window, "closeclick", $.proxy(this.closeCoursePoint, this));
    if(sticky) {
      google.maps.event.addListener(window, "domready", $.proxy(function() {
        this.initPointPhotoWidget(cp);
        this.initInfoWindowHandlers();
      }, this));
      this.disableClicks(); //disable map interaction while infowindow is open
      this.openCoursePoint = cp;
    }
    window.open(this.gmap);
    if(sticky) {
      this.stickyInfoWindow = window;
      this.previewInfoWindow = null;
    } else {
      this.stickyInfoWindow = null;
      this.previewInfoWindow = window;
    }
  },

  contentForCoursePointInfoWindow: function(cp) {
    if(this.inPlanningMode() && rwgps.config.privileges['advanced_planning']) {
      return cp.editHtml();
    } else { //just show it
      return cp.showHtml();
    }
  },
  deleteCoursePoint: function(cp) {
    cp = cp || this.openCoursePoint;
    if(!cp) return;
    cp.segment.removeCoursePoint(cp);
    this.closeCoursePoint();
    this.snapshot();
  },
  closeCoursePoint: function() {
    this.openCoursePoint = null;
    if (this.stickyInfoWindow) {
      this.stickyInfoWindow.close();
      this.enableClicks(); //re-enable map interaction since infowindow is closed...
    }
  },
  saveCoursePoint: function(cp) {
    cp = cp || this.openCoursePoint;
    if(!cp) return;
    var oldRow = cp.row;
    cp.type = $("#coursePointInfoWindowContent select.coursePointType").val();
    cp.notes = $("#coursePointInfoWindowContent textarea.coursePointDescription").val();
    cp.description = $("#coursePointInfoWindowContent textarea.coursePointLongDescription").val();
    cp.edited = true; // always display cp markers for edited cps
    if(Routes && Routes.Common) cp.row = Routes.Common.createCoursePointRow(cp);
    if(!cp.marker) cp.marker = new rwgps.CoursePointIcon(cp, this);

    if(oldRow) { //editing, not adding a new one
      oldRow.after(cp.row).remove();
    } else {
      //new point, let's be lazy and just redraw the whole thing instead
      //of figuring out where to insert the point
      cp.segment.insertCoursePoint(cp);
      rwgps.Events.trigger("cp:populate", cp.segment.route.coursePoints(), false);
    }
    this.closeCoursePoint();
    this.snapshot();
  },

  initializeLocallySavedRoute: function() {
    if(this.mode == "plan") $.jStorage.deleteKey("locallySavedRoute");
  },

  callWhenReady: function(fn) {
    if(this._mapIsReady) {
      fn()
    } else if(this.gmap && this.gmap.getMapTypeId() != null) {
      _.defer(() => {
        this._mapIsReady = true
        fn()
      })
    } else {
      var self = this;
      setTimeout(function() { self.callWhenReady(fn); }, 100);
    }
  },

  setOption: function(opt, val) {
    if(opt.match("avoid")) this.clickOptions.setOption(opt, val);
    switch(opt) {
      case "show_coursepoint_icons":
        this.showCoursePointIcons = val;
        if(val) {
          this.drawCoursePointIcons(this.activeRoute.coursePoints());
        } else {
          this.removeCoursePointIcons(this.activeRoute.coursePoints());
        }
        break;
      case "show_control_point_icons":
        this.showControlPointIcons = val;
        if(val) {
          this.activeRoute.drawControlPoints(this);
        } else {
          this.activeRoute.clearControlPoints();
        }
        break;
      case "auto_center":
        this.opts.autoCenter = val;
        break;
      case "show_distance_markers":
        this.distanceMarkersEnabled(val);
        break;
      case "generate_cues":
        this.generateCues(val);
        break;
      case 'show_pois':
        this.opts.poiEnabled = val
        if(val) {
          for(var i = 0; i < this.pointsOfInterest.length; i++) {
            this.pointsOfInterest[i].marker.gmarker.setMap(this.gmap);
          }
        } else {
          for(var x = 0; x < this.pointsOfInterest.length; x++) {
            this.pointsOfInterest[x].marker.gmarker.setMap(null);
          }
        }
        break;
      case "enable_scrollwheel_zoom":
        this.gmap.set('scrollwheel', val ? true : false);
        this.opts.scrollwheel = val;
        break;
      case 'show_surface':
        this.opts.showSurface = val;
        if (val) {
          this.activeRoute.segments.forEach(seg => seg.sPolylines.forEach(pl => pl.setMap(this.gmap)))
        } else {
          // map over and remove only surface gPolylines
          this.activeRoute.segments.forEach(seg => seg.sPolylines.forEach(pl => pl.setMap(null)))
        }
    }
  },

  loadElevationProfile: function() {
    if(!this.debouncedLoadElevationProfile) {
      this.debouncedLoadElevationProfile = _.debounce(this.realLoadElevationProfile, 100);
    }
    this.debouncedLoadElevationProfile();
  },
  realLoadElevationProfile: function() {
    if($('#elevation_profile').length == 0) return;
    var points = this.activeRoute.trackPoints();
    if(Routes.sampleGraph) {
      // if we're not already loading elevation, check for nulls and load them up while we're here
      // this should happen on-load for a bad route, and after the rare case where the null eles get
      // set. that means it shouldn't happen often, so use badEleLoadSemaphore to throttle it heavily
      if(this.inPlanningMode() && !this.badEleLoadSemaphore) {
        // we fetch ele from latlng, so filter out points missings those values too
        var pointsWithoutEle = _.filter(points, function(pt) {
          return !pt.fetchingEle && pt.lat && pt.lng && (pt.ele === undefined || pt.ele === null);
        });
        if(pointsWithoutEle.length > 0) {
          this.badEleLoadSemaphore = true;
          var that = this;
          setTimeout(function() { delete that.badEleLoadSemaphore; }, 5000);
          this.fetchElevations(pointsWithoutEle, $.proxy(function() {
            this.loadElevationProfile();
            this.snapshot({updateLast: true});
          }, this), function(msg) { trace(msg) });
        }
      }

      Routes.sampleGraph.data(points);
      Routes.sampleGraph.render();
      if(this.afterLoadElevationProfileFn) this.afterLoadElevationProfileFn();
    } else {
      // try again, not loaded yet
      var self = this;
      setTimeout(function() { self.loadElevationProfile(); }, 100);
    }
  },

  /* playback features */
  setPlaybackSpeed: function(val) {
    try {
      Routes.sampleGraph.setPlaybackSpeed(val);
    } catch(e) {} // eslint-disable-line no-empty
  },
  setPlaybackPercentage: function(val) {
    try {
      Routes.sampleGraph.setPlaybackPercentage(val);
    } catch(e) {} // eslint-disable-line no-empty
  },
  startPlayback: function() {
    try {
      Routes.sampleGraph.play();
      this._playing = true;
      this._paused = false;
      google.maps.event.clearListeners(this.gmap, 'mousemove');
    } catch(e) {} // eslint-disable-line no-empty
  },
  pause: function() {
    try {
      Routes.sampleGraph.pause();
      this._playing = false;
      this._paused = true;
    } catch(e) {} // eslint-disable-line no-empty
  },
  stopPlayback: function() {
    try {
      Routes.sampleGraph.stopPlayback();
      this._playing = false;
      this._paused = false;
      this.unhighlightNearestPoint();
      // sometimes the flash movie fires an extra updatePlayhead call after we have told it to stop, so keep a flag set for 250 ms to prevent it
      this.keepPlayheadStopped = true;
      var self = this;
      setTimeout(function() { self.keepPlayheadStopped = false; }, 250);
      google.maps.event.clearListeners(this.gmap, 'mousemove');
      google.maps.event.addListener(this.gmap, 'mousemove', $.proxy(this.onMouseMove, this));
    } catch(e) {} // eslint-disable-line no-empty
  },
  updatePlayhead: function(pt, tps) {
    // update elapsed time if the points have time attrs
    if(pt && pt.time && !this.keepPlayheadStopped) {
      if(!tps) tps = this.activeRoute.trackPoints();

      var time = pt.time,
        min_time = tps[0].time,
        max_time = tps[tps.length-1].time;
      if(!max_time)
        max_time = tps[tps.length-2].time;
      var seconds = time - min_time;
      var pct = Math.round(100 * seconds / (max_time - min_time));
      if($.ui && $.ui.slider && $("#elapsed_time_slider").data("ui-slider")) {
        $("#elapsed_time_slider").slider('option', 'value', pct);
        $('#elapsed_time').html(rwgps.LabelMaker.durationLabel(seconds));
      }
    }
  },


  /**
  * @param {google.maps.Map} map
  * @param {google.maps.LatLng} latlng
  * @param {int} z
  * @return {google.maps.Point}
  *
  * http://qfox.nl/notes/116
  */
  googleLatLngToPoint: function(latlng) {
    var z = this.gmap.getZoom();
    var normalizedPoint = this.gmap.getProjection().fromLatLngToPoint(latlng); // returns x,y normalized to 0~255
    var scale = Math.pow(2, z); //each zoom level ^2 tile size
    var pixelCoordinate = new google.maps.Point(normalizedPoint.x * scale, normalizedPoint.y * scale);
    return pixelCoordinate;
  },
  /**
  * @param {google.maps.Map} map
  * @param {google.maps.Point} point
  * @param {int} z
  * @return {google.maps.LatLng}
  *
  * http://qfox.nl/notes/116
  */
  pointToGoogleLatLng: function(point) {
    var z = this.gmap.getZoom();
    var scale = Math.pow(2, z);
    var normalizedPoint = new google.maps.Point(point.x / scale, point.y / scale);
    var latlng = this.gmap.getProjection().fromPointToLatLng(normalizedPoint);
    return latlng;
  },
  googleLatLngToContainerPoint: function(latLng) {
    var proj = this.gmap.getProjection();
    var bounds = this.gmap.getBounds();
    var tr = proj.fromLatLngToPoint(bounds.getNorthEast());
    var bl = proj.fromLatLngToPoint(bounds.getSouthWest());
    var scale = Math.pow(2, this.gmap.getZoom());
    var wp = proj.fromLatLngToPoint(latLng);
    return new google.maps.Point((wp.x- bl.x)*scale, (wp.y - tr.y)*scale);
  },
  gBoundsToObj: function(b) {
    var ne = b.getNorthEast(), sw = b.getSouthWest();
    return {
      ne: {lat: ne.lat(), lng: ne.lng()},
      sw: {lat: sw.lat(), lng: sw.lng()}
    }
  },
  getBounds: function() {
    var bounds = this.gmap.getBounds();
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();
    return {
      ne: {lat: ne.lat(), lng: ne.lng()},
      sw: {lat: sw.lat(), lng: sw.lng()}
    };
  },

  // Eliminate sections of surface that are < 0.1 miles in length. This happens a lot when intersecting with a road with a different surface type
  eliminateLoneSurfaces: function (trackPoints) {
    const surfaceGroups = rwgps.surfaces.surfaceGroups
    const MAX_WINDOW_SIZE = 161 // 0.1 miles
    const surfaceWindow = []
    let i, tp
    const windowDistance = () => (
      surfaceWindow.length < 4 ? 0 : trackPoints[i - 1].distance - trackPoints[i - (surfaceWindow.length - 2)].distance
    )
    for (i = 0; i < trackPoints.length; i++) {
      tp = trackPoints[i]
      surfaceWindow.push(surfaceGroups[tp.surface])
      // remove points from the front of the window until the window meets our distance constraint
      while (windowDistance() > MAX_WINDOW_SIZE) {
        surfaceWindow.shift()
      }
      if (surfaceWindow.length > 2) { // need at least 3 points to find a lone surface to eliminate
        const len = surfaceWindow.length
        // check to see if the first and last surfaces are the same, but the second to last is different
        if (surfaceWindow[0] !== surfaceWindow[len - 2] && surfaceWindow[0] === surfaceWindow[len - 1]) {
          for (let counter = 1; counter < len - 1; counter++) {
            const pointToCoerce = trackPoints[i - counter]
            pointToCoerce.roadClass = tp.roadClass
            pointToCoerce.ghSurface = tp.ghSurface
            pointToCoerce.surface = tp.surface
            surfaceWindow[len - counter - 1] = surfaceGroups[tp.surface] // keep cached value in our window updated
          }
        }
      }
    }
  },

  injectSurfaces: function(trackPoints, error) {
    trackPoints.forEach(tp => { tp.fetchingSurface = true; })
    var batches = [], offset = 0, count = 70;
    while (offset <= trackPoints.length) {
      batches.push(trackPoints.slice(offset, offset + count));
      offset += count;
    }

    const surfaceBatch = tps => cb => {
      const data = JSON.stringify({
        track_points: tps.map(tp => (tp.point
          ? { y: tp.point.lat, x: tp.point.lng }
          : { y: 0, x: 0 } // {0,0} is in the middle of the ocean -> unknown
        ))
      })
      $.ajaxSettings.stopCSRF = true;
      $.ajax({
        url: 'https://directions.ridewithgps.com/surfaceinjector',
        dataType: "json",
        contentType: 'application/json',
        type: 'POST',
        data: data,
        success: response => {
          var roadClass, ghSurface, surface;
          response.track_points.forEach((r, k) => {
            roadClass = rwgps.surfaces.roadClassToInt[r['R']];
            ghSurface = rwgps.surfaces.surfaceToInt[r['S']];
            surface = rwgps.TrackPoint.inferSurface(ghSurface, roadClass, r.y, r.x);
            if (surface === undefined) { // 99 is UNKOWN
              ghSurface = 99;
              surface = 99;
            }
            tps[k].roadClass = roadClass;
            tps[k].ghSurface = ghSurface;
            tps[k].surface = surface;
            tps[k].roadEnv = ['bridge', 'tunnel'].includes(r['RE']) ? 1 : 0
          })
          cb(null, tps)
        },
        error: err => cb(err, null)
      })
    }

    async.parallelLimit(batches.map(surfaceBatch), 6, (err) => {
      if (err) {
        error("No routes found");
        return
      }

      trackPoints.forEach(tp => { delete tp.fetchingSurface })

      const prevSeg = trackPoints[0].segment && trackPoints[0].segment.prevControlPoint.prevSegment
      if (prevSeg) {
        // the right move here would be to walk backward the window of 0.1 miles that we look at to eliminate lone surfaces
        // this simpler approach has two flaws:
        // 1. overridden surface types within the previous segment that last less than 0.1 miles will get eliminated
        // 2. if the previous segment is less than 0.1 miles and the previous-previous segment has a problem at control point boundary, it won't be fixed
        // not solving these problems right now because the solution is enough more complex that it's not worth it unless we see these issues more often than almost-never
        this.eliminateLoneSurfaces(prevSeg.trackPoints.concat(trackPoints))
      } else {
        this.eliminateLoneSurfaces(trackPoints)
      }

      const map = window.Routes.activeMap
      if (!map.activeRoute.showSurface && rwgps.config.labs.surface_types && rwgps.config.labs.route_planner) {
        map.activeRoute.showSurface = true
        Routes.sampleGraph.showSurface(true)
      }
      map.activeRoute.recalculatePolylines()
      window.rwgps.Events.trigger('surfacesChanged')
      // surfaces are fetched concurrently with elevation data, and once the elevation is fetched it will update the profile and perform a snapshot.
      // if elevations are already fetched, we need to update the snapshot and redraw the profile again.
      // if elevations are still being fetched, we can let the success handler for fetchElevations take the snapshot and redraw the profile.
      if (!_.find(trackPoints, tp => tp.fetchingEle)) {
        map.activeRoute.flattenBridgesAndTunnels()
        map.loadElevationProfile()
        map.snapshot({ updateLast: true })
      }
    })
  },

  /*
   * We are splitting up elevation requests into chunks of 70 points at a time
   * since this is GET and some browsers (IE) have a limit on URL string
   * lengths.
   */
  fetchElevations: function(trackPoints, success) {
    // store fetch state on the trackPoint
    for(var i=0,len=trackPoints.length; i < len; i++) {
      trackPoints[i].fetchingEle = true;
    }
    var batches = [], offset = 0, count = 70;
    while(offset <= trackPoints.length) {
      batches.push(trackPoints.slice(offset, offset+count));
      offset += count;
    }
    // keep track of how many requests we're processing, and the last
    // request that comes back can fire the success callback
    var numToComplete = 0;
    for(var j = 0; j < batches.length; j++) {
      numToComplete += 1;
      //use an anonymous function for a new scope, so callbacks don't share
      //a points array and get all confused
      (function(idx) {
        var lats = "", lngs = "";
        var points = batches[idx];
        for(var i = 0; i < points.length; i++) {
          lats += Math.round(points[i].point.lat*1000000)/1000000 + ",";
          lngs += Math.round(points[i].point.lng*1000000)/1000000 + ",";
        }
        lats = lats.slice(0, lats.length - 1);
        lngs = lngs.slice(0, lngs.length - 1);

        $.ajax({
          url: "https://gis.ridewithgps.com/get_eles",
          data: {lats: lats, lngs: lngs},
          dataType: "jsonp",
          type: "get",
          success: function(response) {
            for(i = 0; i < points.length; i++) {
              points[i].ele = response[i];
              delete points[i].fetchingEle;
              // if this point as been flattened by flattenBridgesAndTunnels,
              // fetchElevations will revert that. update point as such
              delete points[i].flattened;
            }
            numToComplete -= 1;
            if(numToComplete == 0) {
              success();
            }
          },
          error: function(request, txt, error) { // eslint-disable-line no-unused-vars
            for(i = 0; i < points.length; i++) {
              delete points[i].fetchingEle;
            }
            //trace("Something broke: " + txt + ", " + error);
          }
        });
      })(j);
    }
  }
};


rwgps.CoursePointPopup = function(map) {
  this.map = map;
  this.div = $("<div/>");
  this.div.css({
    position: "absolute",
    background: "#FFF",
    "z-index": 10,
    padding: 3,
    border: "1px solid black"
  });
  //this.setCoursePoint(cp);
}
rwgps.CoursePointPopup.prototype = {
  setCoursePoint: function(cp) {
    if(!cp) return null;
    var pt = this.map.googleLatLngToContainerPoint(cp.googleLatLng());
    var margin = $('#'+this.map.opts.targetDiv).offset().left;
    var x = pt.x + 20 + margin;

    this.div.html("");

    if(cp.photoIds.length > 0) {
      this.div.css({width:150, height:65});
      //this.div.append("<br/>");
      var cont = $("<div style='float:left;border:1px solid #CCC;padding:2px;width:60px;height:60px;margin-right:3px;'/>");
      cont.append("<img class='left' src='/photos/micro/" + cp.photoIds[0] + ".jpg' />");
      this.div.append(cont);
    } else {
      this.div.css({width:120, height:30});
    }
    this.div.append("<span class='left'><b>" + cp.type + "</b></span>");
    //this.div.append("<span style='margin-left:5px'>" + cp.notes + "</span>");

    this.div.css({left: x, top: pt.y + 20});
  },
  show: function() {
    $("body").append(this.div);
  },
  hide: function() {
    this.div.remove();
  }
}

rwgps.MouseSpeedometer = function() {
  this.speed = this.x = this.y = this.t = 0;
}
rwgps.MouseSpeedometer.ZERO_TIMEOUT = 100;
rwgps.MouseSpeedometer.UPDATE_THROTTLE = 50;
rwgps.MouseSpeedometer.prototype.update = function(x, y) {
  const t = (new Date()).getTime();
  let updateState = false;
  if(this.t > 0 ) {
    const xD = x - this.x,
      yD = y - this.y,
      tD = t - this.t;
    if(tD > rwgps.MouseSpeedometer.UPDATE_THROTTLE) {
      const instSpeed = Math.sqrt(xD * xD + yD * yD) / tD;
      // ease speed updates to smooth out jerkiness
      this.speed = this.speed * 0.8 + instSpeed * 0.2;
      updateState = true;

      // drop speed to zero if we don't get an update for too long
      if(this.zeroTimeout) {
        clearTimeout(this.zeroTimeout);
      }
      this.zeroTimeout = setTimeout(() => { this.speed = 0; }, rwgps.MouseSpeedometer.ZERO_TIMEOUT);
    }
  } else {
    updateState = true;
  }
  if(updateState) {
    this.x = x;
    this.y = y;
    this.t = t;
  }
};


rwgps.Icon = function() {}
rwgps.Icon.prototype = {
  map: null,
  icon: null,
  shadow: null,
  gmarker: null,

  init: function(latlng, opts) {
    if(!opts) opts = {};
    if (!latlng) latlng = {}
    let iconObj = this.icon;
    if(this.size) {
      iconObj = {scaledSize: this.size, url: this.icon}
    }
    opts = $.extend({
      position: new google.maps.LatLng(latlng.lat, latlng.lng),
      clickable: true,
      icon: iconObj,
      shadow: this.shadow
    }, opts);

    this.gmarker = new google.maps.Marker(opts);
    if(this.map) this.gmarker.setMap(this.map.gmap);

    var self = this;
    //debounced, because if we don't, we get flutter as the lower zindex icon moves up
    //and kicks off another mouseover/leave event, which causes the previous icon
    //to have this kicked off.  Thus, it just cycles back and forth.
    google.maps.event.addListener(this.gmarker, 'mouseover', _.debounce(function() {
      self.map.topZIndex += 1;
      self.gmarker.setZIndex(self.map.topZIndex);
    }));
  },

  enableDragEdit: function() {
    var firstSeg, lastSeg, startMarker,
      firstPoint, lastPoint,
      service,
      directionsRequestFn,
      mouseSpeedometer,
      finalTps, finalCps, lastDragEvent,

      isControlPoint,
      controlPoint,
      isFirst,
      isLast,
      isMiddle,
      useMapClickOpts,
      isFirstSegFollowRoads,
      isLastSegFollowRoads,

      afterDirectionsFn, // called when awaitingDirections == 0, used to defer dragend
      awaitingDirections=0; // new directions req will +1, and when returned, -1

    var dragEndFn = $.proxy(function(e) {
      this.map.draggingMarker = false;

      //remove the temporary polylines from the map
      if(this.dragPolyline1) {
        this.dragPolyline1.setMap(null); this.dragPolyline1.setPath([]); this.dragPolyline1 = null;
      }
      if(this.dragPolyline2) {
        this.dragPolyline2.setMap(null); this.dragPolyline2.setPath([]); this.dragPolyline2 = null;
      }

      //completely remove our old segments, we are drawing new ones from scratch
      if(firstSeg) firstSeg.removeFromMap();
      if(lastSeg) lastSeg.removeFromMap();

      var points, coursePoints;
      var newPoint = new rwgps.TrackPoint({point: {lat: e.latLng.lat(), lng: e.latLng.lng()}});
      var newFirstSeg, newLastSeg;

      // construct first segment, if splitting directions this seg will have all the points until we split it upon constructing the latter segment in the block that follows
      var path, isFollowRoads, seg;
      if(isFirst) {
        path = [newPoint, lastPoint];
        isFollowRoads = isLastSegFollowRoads;
        seg = lastSeg;
      }
      if(isMiddle || isLast) {
        path = [firstPoint, newPoint];
        isFollowRoads = isFirstSegFollowRoads;
        seg = firstSeg;
      }

      if(!isFollowRoads) {
        points = rwgps.Segment.fillTheCracks(path);
        coursePoints = [];
      } else {
        if(!finalTps) {
          // should put all this in some sort of "ensure" block
          trace("Aborting drag/drop, expected results and there are none");
          if(firstSeg) firstSeg.addToMap(this.map);
          if(lastSeg) lastSeg.addToMap(this.map);
          this.map.loadElevationProfile();
          this.map.relabel();
          this.map.activeRoute.calculateMetrics();
          this.map.activeRoute.rebuildBounds();
          // draw distance markers
          this.map.drawRouteDistanceMarkers(this.map.activeRoute);
          this.map.drawCoursePointIcons(this.map.activeRoute.coursePoints());
          this.map.populateCuesheet(this.map.activeRoute.coursePoints());
          this.map.snapshot();
          // restore default mousemove listener
          google.maps.event.addListener(this.map.gmap, 'mousemove', $.proxy(this.map.onMouseMove, this.map));
          return;
        }
        points = finalTps;
        coursePoints = finalCps;
      }

      // make sure route stays contiguous
      var firstSegPrevCp, firstSegNextCp;
      if(!isFirst && firstSeg.prevSegment) {
        var priorSeg = firstSeg.prevSegment,
          priorSegCp = priorSeg.nextControlPoint;
        if(points[0].pointEquals(priorSegCp.point)) {
          // first point is a dupe of the prev cp so get rid of it
          points.shift();
        }
        firstSegPrevCp = priorSegCp;
      } else {
        firstSegPrevCp = points.shift();
      }
      // if we are editing the end of the route (isLast or isMiddle but next seg is the last) still need to provide our own cp
      if(lastSeg && lastSeg.nextSegment) {
        if(points.length > 0 && points[points.length-1].pointEquals(lastSeg.nextControlPoint.point)) {
          points.pop();
        }
        if(isMiddle && (!isLastSegFollowRoads || !isFirstSegFollowRoads)) {
          firstSegNextCp = points.pop();
        } else {
          firstSegNextCp = lastSeg.nextControlPoint;
        }
      } else {
        firstSegNextCp = points.pop();
      }
      newFirstSeg = new rwgps.Segment(this.map.activeRoute, firstSegPrevCp, firstSegNextCp, points, coursePoints, seg.color);
      newFirstSeg.clickOptions.setOptions(seg.clickOptions.getOptions());

      // give startmarker its new point if necessary
      if(startMarker) {
        startMarker.trackPoint = newFirstSeg.prevControlPoint;
        startMarker.gmarker.setPosition(newFirstSeg.prevControlPoint.googleLatLng());
      }

      var lastPtOnFirstSeg = newFirstSeg.nextControlPoint;

      // construct second segment if necessary
      if(isMiddle) {
        var lastSegNextCp;
        if(!isLastSegFollowRoads) {
          points = rwgps.Segment.fillTheCracks([newPoint, lastPoint]);
          // dropping dupes
          if(points[0].pointEquals(lastPtOnFirstSeg.point)) {
            points.shift();
          }
          if(lastSeg.nextSegment) {
            lastSegNextCp = lastSeg.nextControlPoint;
            if(points.length > 0 && points[points.length-1].pointEquals(lastSegNextCp.point)) {
              points.pop();
            }
          } else {
            lastSegNextCp = points.pop();
          }
          coursePoints = [];
          newLastSeg = new rwgps.Segment(this.map.activeRoute, lastPtOnFirstSeg, lastSegNextCp, points, coursePoints, lastSeg.color);
          newLastSeg.clickOptions.setOptions(lastSeg.clickOptions.getOptions());
        } else if(isFirstSegFollowRoads) {
          this.trackPoint = new rwgps.TrackPoint({point: {lat: e.latLng.lat(), lng: e.latLng.lng()}});
          var closestIdx = 0;
          var closestDist = 99999;
          for(var i = 0; i < newFirstSeg.trackPoints.length; i++ ) {
            var tp = newFirstSeg.trackPoints[i];
            var dist = tp.distanceFromPoint(this.trackPoint);
            if(dist < closestDist) {
              closestDist = dist;
              closestIdx = i;
            }
          }
          if(closestDist < 99999) { //actually found something, so let's split
            newLastSeg = newFirstSeg.splitAfter(closestIdx - 1);
          }
        } else { // first seg is draw lines, second seg is follow roads...
          points = finalTps;
          if(points[0].pointEquals(lastPtOnFirstSeg.point)) {
            points.shift();
          }
          if(lastSeg.nextSegment) {
            lastSegNextCp = lastSeg.nextControlPoint;
          } else {
            lastSegNextCp = points.pop();
          }
          coursePoints = finalCps;
          newLastSeg = new rwgps.Segment(this.map.activeRoute, lastPtOnFirstSeg, lastSegNextCp, points, coursePoints, lastSeg.color);
          newLastSeg.clickOptions.setOptions(lastSeg.clickOptions.getOptions());
        }
      }

      newLastSeg = newLastSeg || newFirstSeg;
      if(!newLastSeg.nextSegment) {
        // have to re-assign prevClick since we moved last segment in route
        this.map.prevClick = newLastSeg.nextControlPoint.point;
      }

      // final cleanup and draws
      const updatePlanner = $.proxy(function() {
        this.loadElevationProfile();
        this.relabel();
        this.activeRoute.calculateMetrics();
        this.activeRoute.rebuildBounds();
        this.activeRoute.redrawPolylines();
        this.activeRoute.flattenBridgesAndTunnels();
        this.drawRouteDistanceMarkers(this.activeRoute);
        this.drawCoursePointIcons(this.activeRoute.coursePoints());
        this.populateCuesheet(this.activeRoute.coursePoints());
        this.snapshot();
        // see if we introduced a spur and fix if so
        if (isMiddle) {
          rwgps.checkSpur(newFirstSeg)
        }
      }, this.map)

      // fetch elevations for all points missing eles
      var trackPoints = newFirstSeg.route.trackPoints();
      var ptsToFetch = [];
      for(var j = 0; j < trackPoints.length; j++) {
        if(trackPoints[j].ele == undefined || trackPoints[j].ele == null) {
          ptsToFetch.push(trackPoints[j]);
        }
      }

      if(ptsToFetch.length > 0) {
        this.map.fetchElevations(
          ptsToFetch,
          updatePlanner,
          function(msg) { trace(msg) }
        );
      } else {
        updatePlanner()
      }

      // fetch surface types for the new segments if we're dragging in gmaps
      const router = Routes.activeMap.activeRoutingService
      if (router.opts.id === 'google') {
        this.map.injectSurfaces(ptsToFetch, () => {})
      }

      // restore the normal listener
      google.maps.event.addListener(this.map.gmap, 'mousemove', $.proxy(this.map.onMouseMove, this.map));
    }, this);

    google.maps.event.addListener(this.gmarker, 'dragstart', $.proxy(function() {
      if(this.map.opts.tripId) {
        rwgps.Events.trigger("trip:modification_prevented");
        return;
      }
      if(this.map.draggingMarker) return;
      rwgps.unhighlightPoints(true);
      this.map.clearSegment();

      // remove all distance markers
      this.map.removeRouteDistanceMarkers(this.map.activeRoute);

      // reset everything
      isControlPoint = !(this instanceof rwgps.NearestPointIcon);
      controlPoint = startMarker = isFirst = isLast = isMiddle = useMapClickOpts = isFirstSegFollowRoads = isLastSegFollowRoads = lastSeg = firstPoint = lastPoint = service = directionsRequestFn = finalTps = finalCps = lastDragEvent = afterDirectionsFn = undefined;
      mouseSpeedometer = new rwgps.MouseSpeedometer();
      awaitingDirections = 0;

      // google doesnt always throw drag end!
      lastDragEvent = {};
      var self=this;
      function emergencyDragEnd() {
        $(window).unbind('mouseup', emergencyDragEnd);
        if(self instanceof rwgps.StartIcon && self.map.activeRoute.segments.length === 0) {
          // no route, we were dragging the start marker! let's reset the prevClick so pos sticks
          const gll = self.gmarker.getPosition();
          self.map.prevClick = {lat: gll.lat(), lng: gll.lng()};
        }
        if(!self.map.draggingMarker) return;
        google.maps.event.clearInstanceListeners(self);
        if(awaitingDirections)
          afterDirectionsFn = function() { dragEndFn(lastDragEvent); };
        else
          dragEndFn(lastDragEvent);
      }
      $(window).mouseup(emergencyDragEnd);

      //set up our boolean state vars
      if(!isControlPoint) {
        // we're only modifying 1 existing seg, so use map click opts
        useMapClickOpts = true;
        // if were on the nearestpointmarker, split the segment up and pretend like we are dragging on the new control point
        firstSeg = this.map.nearestMousePointBehind.segment || this.map.nearestMousePointBehind.nextSegment;

        var pointBehindI = _.indexOf(firstSeg.trackPoints, this.map.nearestMousePointBehind),
          p = this.map.nearestInterpolatedMousePoint,
          distance = this.map.nearestMousePointBehind.distance + this.map.nearestMousePointBehind.distanceFromLatLng(p),
          tp = new rwgps.TrackPoint({point: p});
        tp.distance = distance;

        firstSeg.insertTrackPointAfter(tp, pointBehindI);
        lastSeg = firstSeg.splitAfter(pointBehindI < 0 ? -1 : pointBehindI + 1);
        this.trackPoint = tp;

        controlPoint = firstSeg.controlPointIcon;
        controlPoint.gmarker.setVisible(false);
        isControlPoint = true;
      } else {
        // we could be sitting between two segs, so since its ambiguous dont use map clickopts (if isFirst or isLast, we'll set this back to true below)
        useMapClickOpts = false;

        controlPoint = this;
        if(!this.trackPoint) {
          if(this.map.activeRoute.segments.length == 0) return; // get out of here! there isnt a route yet
          this.trackPoint = this.map.activeRoute.firstSegment.prevControlPoint;
        }
        firstSeg = this.trackPoint.segment || this.trackPoint.prevSegment || this.trackPoint.nextSegment;
        lastSeg = firstSeg.nextSegment;
        if(this instanceof rwgps.StartIcon) {
          startMarker = this;
          lastSeg = firstSeg ; firstSeg = null ;
        }
      }
      // if dragging next to start marker, we'll need to reassign its trackpt and position afterward
      if(firstSeg && !firstSeg.prevSegment && firstSeg.route.startMarker) {
        startMarker = firstSeg.route.startMarker;
      }

      isFirst = !firstSeg;
      isLast = !lastSeg;
      if(isFirst || isLast || (firstSeg.clickOptions.getOptions() == lastSeg.clickOptions.getOptions())) {
        // only 1 seg affected by the drag operation, or both segs have matching click options,
        // so use map click opts
        useMapClickOpts = true;
      }
      isMiddle = !isFirst && !isLast;
      // if we should use map click opts, set them now
      if(useMapClickOpts) {
        var mapClickOpts = this.map.clickOptions.getOptions();
        if(firstSeg) firstSeg.clickOptions.setOptions(mapClickOpts);
        if(lastSeg) lastSeg.clickOptions.setOptions(mapClickOpts);
      }
      if(firstSeg) isFirstSegFollowRoads = !!firstSeg.clickOptions.followRoads();
      if(lastSeg) isLastSegFollowRoads = !!lastSeg.clickOptions.followRoads();

      if(lastSeg)
        lastPoint = lastSeg.nextControlPoint;
      else
        lastPoint = firstSeg.nextControlPoint;

      if(firstSeg)
        firstPoint = firstSeg.prevControlPoint;
      else
        firstPoint = lastSeg.prevControlPoint;

      this.map.draggingMarker= true;
      google.maps.event.clearListeners(this.map.gmap, "mousemove");

      // this.map.unhighlightNearestPoint();

      // hide the segments
      if(firstSeg) {
        firstSeg.clearCoursePointMarkers();
        firstSeg.gPolylines.forEach(pl => pl.setMap(null));
        if(firstSeg.backgroundPolyline) firstSeg.backgroundPolyline.setMap(null);
      }
      if(lastSeg) {
        lastSeg.clearCoursePointMarkers();
        lastSeg.gPolylines.forEach(pl => pl.setMap(null));
        if(lastSeg.backgroundPolyline) lastSeg.backgroundPolyline.setMap(null);
      }

      // build a function to request directions if necessary
      if(isFirstSegFollowRoads || isLastSegFollowRoads) {
        service = this.map.activeRoutingService;

        var unlimitedDirectionsRequestFn = $.proxy(function(path, opts, color, whichpl) {
          var self = this,
            pl = "dragPolyline" + (whichpl || 1);

          awaitingDirections += 1;

          service.getDirections(path, opts, color,
            function(tps, cps) {
              if(tps == null || tps.length == 0) return;
              if(!self.map.opts.generateCues)
                cps = null;
              var latlngs = _.map(tps, function(pt) { return pt.point });

              // make sure path stays contiguous
              if(!tps[0].pointEquals(path[0]))
                latlngs.unshift(path[0]);
              if(!tps[tps.length-1].pointEquals(path[path.length-1]))
                latlngs.push(path[path.length-1]);

              const googleLatLngs = latlngs.map(x => new google.maps.LatLng(x.lat, x.lng))
              if(self[pl]) { self[pl].setPath(googleLatLngs) }
              else { self[pl] = new google.maps.Polyline({path: googleLatLngs, map: self.map.gmap}) }
              finalTps = tps; finalCps = cps;
              awaitingDirections -= 1;
              if(awaitingDirections == 0 && afterDirectionsFn) afterDirectionsFn();
            },
            function(err) {
              trace(["error while requesting directions on drag to edit", err]);
              awaitingDirections -= 1;
              if(awaitingDirections == 0 && afterDirectionsFn) {
                afterDirectionsFn();
              }
            }
          );
          if(!window.dragCount)
            window.dragCount = 1
          else
            window.dragCount += 1


          var group = rwgps.config.labs.prevent_sticky_gmaps ? 'A' : 'B'
          trackEvent('Google Maps', `Direction Request (Drag - ${group})`, service.opts.type);
          trackEvent('Google Maps', 'Direction Request (Drag)', service.opts.type);
        }, this);

        // combine a throttle and debounce - this ensures that as you drag, the throttled fn keeps executing, and once you settle the mouse, your last position will get a directions request due to the debounce!
        const DIR_VERY_SLOW_THROTTLE=2000,
          DIR_SLOW_THROTTLE=900,
          DIR_SLOW_THRESHOLD = 0.09;
        let debounceWaiting, directionsDebounceTimer, directionsThrottleTimer,
          directionsThrottleTime = DIR_VERY_SLOW_THROTTLE,
          directionsCanRun = true,
          mouseIsSlow = false,
          letDirectionsRun = () => { directionsCanRun = true; };

        directionsRequestFn = function() {
          let resetThrottleTo = 0;
          // mouse entered slow state - grab directions now and throttle to slow
          if(!mouseIsSlow && mouseSpeedometer.speed < DIR_SLOW_THRESHOLD) {
            mouseIsSlow = true;
            directionsCanRun = true;
            resetThrottleTo = DIR_SLOW_THROTTLE;
          }
          // mouse entered fast state - throttle to very slow
          if(mouseIsSlow && mouseSpeedometer.speed >= DIR_SLOW_THRESHOLD) {
            mouseIsSlow = false;
            resetThrottleTo = DIR_VERY_SLOW_THROTTLE;
          }

          // reset debounce state
          if(debounceWaiting) {
            debounceWaiting = false;
            awaitingDirections--;
            clearTimeout(directionsDebounceTimer);
          }

          // if throttle timer came up and we're allowed to grab directions, grab them & reset
          if(directionsCanRun) {
            unlimitedDirectionsRequestFn.apply(null, arguments);
            if(!resetThrottleTo)
              resetThrottleTo = directionsThrottleTime;
          } else {
            awaitingDirections++;
            debounceWaiting = true;
            var args = arguments;
            directionsDebounceTimer = setTimeout(function() {
              debounceWaiting = false;
              awaitingDirections--;
              unlimitedDirectionsRequestFn.apply(null, args);
            }, rwgps.MouseSpeedometer.ZERO_TIMEOUT + 100);
          }

          // restart throttling at corretct rate if requested
          if(resetThrottleTo > 0) {
            directionsCanRun = false;
            if(directionsThrottleTimer)
              clearTimeout(directionsThrottleTimer);
            directionsThrottleTimer = setTimeout(letDirectionsRun, resetThrottleTo);
            directionsThrottleTime = resetThrottleTo;
          }
        }
      }
    }, this));


    // dont bother attaching drag and dragend
    if(this.map.opts.tripId) {
      return;
    }

    // helper function we'll call during drag if we're in line mode
    var dragPolylineFn = $.proxy(function(path, whichpl, forceConnect) {
      const googlePath = path.map(x => new google.maps.LatLng(x.lat, x.lng))
      var pl = "dragPolyline" + (whichpl || 1);
      if(forceConnect) {
        var otherpl, opath;
        if(whichpl == 1) {
          if((otherpl = this['dragPolyline2'])) {
            opath = otherpl.getPath();
            opath.insertAt(0, googlePath[googlePath.length-1]);
            otherpl.setPath(opath);
          }
        } else {
          if((otherpl = this['dragPolyline1'])) {
            opath = otherpl.getPath();
            opath.push(googlePath[0]);
            otherpl.setPath(opath);
          }
        }
      }
      if(this[pl]) {
        this[pl].setPath(googlePath);
      } else {
        this[pl] = new google.maps.Polyline({
          path: googlePath,
          map: this.map.gmap
        });
      }
    }, this);

    google.maps.event.addListener(this.gmarker, "drag", $.proxy(function(e) {
      const mousePoint = {lat: e.latLng.lat(), lng: e.latLng.lng()}
      mouseSpeedometer.update(e.pixel.x, e.pixel.y);
      lastDragEvent = e;
      if(!isMiddle || isFirstSegFollowRoads == isLastSegFollowRoads) {
        // only do one thing
        var path;
        if(isFirst)     path = [mousePoint, lastPoint.point];
        else if(isLast) path = [firstPoint.point, mousePoint];
        else if(firstPoint && lastPoint) path = [firstPoint.point, mousePoint, lastPoint.point];
        else path = [];

        var isFollowRoads = (isFirst && isLastSegFollowRoads) || (isLast && isFirstSegFollowRoads) || (isFirstSegFollowRoads && isLastSegFollowRoads)

        if(isFollowRoads) {
          var tempOpts = this.map.clickOptions.getProviderOptions() | this.map.clickOptions.getRestrictionOptions();
          if(isFirst) {
            lastSeg.clickOptions.setPartialOptions(tempOpts);
            directionsRequestFn(path, lastSeg.clickOptions, lastSeg.color);
          } else {
            firstSeg.clickOptions.setPartialOptions(tempOpts);
            directionsRequestFn(path, firstSeg.clickOptions, firstSeg.color);
          }
        } else
          dragPolylineFn(path);
      } else {
        // follow roads on one side, draw a line on the other
        var firstSegPath = [firstPoint.point, mousePoint],
          lastSegPath = [mousePoint, lastPoint.point];

        if(isFirstSegFollowRoads)
          directionsRequestFn(firstSegPath, firstSeg.clickOptions, firstSeg.color);
        else
          dragPolylineFn(firstSegPath, 1, true);

        if(isLastSegFollowRoads)
          directionsRequestFn(lastSegPath, lastSeg.clickOptions, lastSeg.color, 2);
        else
          dragPolylineFn(lastSegPath, 2, true);
      }
    }, this));




    var self=this;
    google.maps.event.addListener(this.gmarker, 'dragend', function(e) {
      if(!self.map.draggingMarker) return;
      google.maps.event.clearInstanceListeners(self);
      if(awaitingDirections) {
        afterDirectionsFn = function() { dragEndFn(e); };
      } else {
        dragEndFn(e);
      }
    });
  },

  _dragEndDirectionsHandler: function() {
  },
  _dragEndPolylineHandler: function() {
  }
}



rwgps.CoursePointIcon = function(coursePoint, map) {
  this.coursePoint = coursePoint;
  this.icon = "/images/cue_icon.png";

  if (coursePoint.deleted) {
    this.icon = "/images/cue_deleted_icon.png"
  }
  if (coursePoint.selected) {
    this.size = new google.maps.Size(36,40);
  } else {
    this.size = new google.maps.Size(24,27);
  }

  this.shadow = new google.maps.MarkerImage(
    "/images/cp_icon_shadow.png",
    new google.maps.Size(32,22), //dimensions
    new google.maps.Point(0,0), //origin to reference from
    new google.maps.Point(3, 22) //anchor (offset a bit for this one)
  );
  this.init(coursePoint.point);
  if(map) this.setMap(map);
}
rwgps.CoursePointIcon.prototype = new rwgps.Icon();
rwgps.CoursePointIcon.prototype.setMap = function(map) {
  var self = this;
  this.map = map;
  this.gmarker.setMap(map.gmap);
  google.maps.event.addListener(this.gmarker, 'click', function() {
    if (!map.inCueReview) {
      map.openCoursePointInfoWindow(self.coursePoint);
    }
  });
  google.maps.event.addListener(this.gmarker, 'mouseover', function() {
    map.coursePointPopup.setCoursePoint(self.coursePoint);
    map.coursePointPopup.show();
  });
  google.maps.event.addListener(this.gmarker, 'mouseout', function() {
    map.coursePointPopup.hide();
  });
  if (rwgps.onRightClick) {
    google.maps.event.addListener(this.gmarker, 'rightclick', (e) => rwgps.onRightClick(e, 'coursePoint', this))
  }
}

rwgps.PoiIcon = function(poi, map) {
  var icon;
  this.poi = poi;
  var poiObj = rwgps.PointOfInterest.poiTypesById[poi.poiType];
  if(poiObj) {
    icon = poiObj.icon;
    if(poi.ghosted) icon = 'alt_' + icon;
    icon = rwgps.poiIconsPath() + icon;
  } else {
    icon = 'poi_icons/generic.png';
  }
  this.size = new google.maps.Size(34,40);
  this.icon = "/images/" + icon;

  this.init(poi.point, {draggable: map.inPlanningMode()});
  if (map.inPlanningMode()) {
    google.maps.event.addListener(this.gmarker, 'dragstart', () => {
      map.closePreviewInfoWindow()
      map.closeStickyInfoWindow()
      this.disableMouseOverOut()
    })
    google.maps.event.addListener(this.gmarker, 'dragend', () => {
      this.poi.point = {lat: this.gmarker.position.lat(), lng: this.gmarker.position.lng()}
      this.enableMouseOverOut()
    })
    if (rwgps.onRightClick) {
      google.maps.event.addListener(this.gmarker, 'rightclick', (e) => rwgps.onRightClick(e, 'pointOfInterest', this))
    }
  }
  if(map) this.setMap(map);
}
rwgps.PoiIcon.prototype = new rwgps.Icon();
rwgps.PoiIcon.prototype.clickHandler = function() {
  this.mouseUpInAction = false;
  this.map.openStickyInfoWindow(this.poi);
  rwgps.Events.trigger("pois:click", this.poi);
}
rwgps.PoiIcon.prototype.disableMouseOverOut = function() {
  google.maps.event.clearListeners(this.gmarker, 'mouseup');
  google.maps.event.clearListeners(this.gmarker, 'mouseover');
  google.maps.event.clearListeners(this.gmarker, 'mouseout');
}
rwgps.PoiIcon.prototype.enableMouseOverOut = function() {
  google.maps.event.addListener(this.gmarker, 'mouseup', $.proxy(this.mouseUpHandler, this));
  google.maps.event.addListener(this.gmarker, 'mouseover', $.proxy(this.mouseOverHandler, this));
  google.maps.event.addListener(this.gmarker, 'mouseout', $.proxy(this.mouseOutHandler, this));
}
rwgps.PoiIcon.prototype.mouseOverHandler = function() {
  if(this.map.preventPoiMouseover) return;
  this.mouseUpInAction = false;
  this.map.openPreviewInfoWindow(this.poi, false); //false to disable auto-panning
  rwgps.Events.trigger("pois:mouseover", this.poi);
  this.map.preventPoiMouseover = false;
}
rwgps.PoiIcon.prototype.mouseOutHandler = function() {
  if(this.map.preventPoiMouseover || this.mouseUpInAction) return;
  this.map.closePreviewInfoWindow();
  rwgps.Events.trigger("pois:mouseout", self.poi);
}
rwgps.PoiIcon.prototype.mouseUpHandler = function() {
  this.mouseUpInAction = true;
}
rwgps.PoiIcon.prototype.setMap = function(map) {
  var self = this;
  this.map = map;
  this.gmarker.setMap(map.gmap);
  google.maps.event.addListener(this.gmarker, 'click', function() { self.clickHandler.apply(self, arguments); });
  this.enableMouseOverOut();
}
rwgps.StartIcon = function(latlng, map) {
  this.map = map;
  this.icon = {
    url: "/images/start.svg",
    size: new google.maps.Size(34, 47),
    anchor: new google.maps.Point(21, 40)
  }

  var opts = {clickable: true, draggable: false};
  if(map.inPlanningMode()) opts.draggable = true;

  this.init(latlng, opts);
  if(map.inPlanningMode()) {
    this.enableDragEdit();
    google.maps.event.addListener(this.gmarker, "click", function(e) {
      map.onClickAddPoint(e);
    });
    if (rwgps.onRightClick) {
      google.maps.event.addListener(this.gmarker, 'rightclick', (e) => rwgps.onRightClick(e, 'startIcon', this))
    }
  }
  this.gmarker.setZIndex(0);
}
rwgps.StartIcon.prototype = new rwgps.Icon();
rwgps.EndIcon = function(latlng, map) {
  this.map = map;
  this.icon = {
    url: "/images/stop.svg",
    size: new google.maps.Size(34, 47),
    anchor: new google.maps.Point(21, 40)
  }
  this.init(latlng);
}
rwgps.EndIcon.prototype = new rwgps.Icon();
rwgps.PointOfInterestIcon = function(latlng, map) {
  this.map = map;
  this.icon = "/images/poi.png";
  this.init(latlng);
}
rwgps.PointOfInterestIcon.prototype = new rwgps.Icon();
rwgps.NearestPointIcon = function(latlng, map) {
  this.map = map;
  this.icon = new google.maps.MarkerImage(
    "/images/nearest_point_icon.png",
    new google.maps.Size(14, 14),
    new google.maps.Point(0,0),
    new google.maps.Point(7,7)
  );
  var planning = window.Routes && Routes.activeMap && Routes.activeMap.inPlanningMode();
  var allowClick = !!(window.Routes && Routes.activeMap && Routes.activeMap.opts.enableNearestPointMarkerClicks);
  this.init(latlng, {clickable: planning || allowClick, draggable: planning && !this.map.inCueReview, raiseOnDrag: false, zIndex: 1});
  if (rwgps.onRightClick) {
    google.maps.event.addListener(this.gmarker, 'rightclick', (e) => rwgps.onRightClick(e, 'nearestPoint', this))
  }
  if(planning)
    this.enableDragEdit();
}
rwgps.NearestPointIcon.prototype = new rwgps.Icon();
rwgps.RacerIcon = function(latlng, map, icon) {
  this.map = map;
  this.icon = new google.maps.MarkerImage(
    "/images/icons/racers/"+icon+".png",
    new google.maps.Size(16, 16),
    new google.maps.Point(0,0),
    new google.maps.Point(8,8)
  );
  this.init(latlng, {clickable: false, draggable: false, raiseOnDrag: false, zIndex: 1});
}
rwgps.RacerIcon.prototype = new rwgps.Icon();
rwgps.ControlPointIcon = function(trackPoint, map) {
  this.map = map;
  this.trackPoint = trackPoint;
  this.icon = new google.maps.MarkerImage(
    "/images/control_point_icon.png?1",
    new google.maps.Size(14, 14),
    new google.maps.Point(0,0),
    new google.maps.Point(7,7)
  );
  this.init(trackPoint.point, {
    zIndex: google.maps.Marker.MAX_ZINDEX + 1,
    raiseOnDrag: false,
    clickable: true,
    draggable: true
  });
  this.enableDragEdit();
  google.maps.event.addListener(this.gmarker, 'mouseover', $.proxy(function() {
    this.unhighlightNearestPoint();
  }, this.map));
  var cp = this;
  google.maps.event.addListener(this.gmarker, 'click', $.proxy(function() {
    rwgps.Events.trigger('map:control_point_clicked', cp);
  }, this.map));
  if (rwgps.onRightClick) {
    google.maps.event.addListener(this.gmarker, 'rightclick', (e) => rwgps.onRightClick(e, 'controlPoint', this))
  }
}
rwgps.ControlPointIcon.prototype = new rwgps.Icon();

rwgps.ConnectionPointIcon = function(trackPoint, map) {
  this.map = map;
  this.trackPoint = trackPoint;
  this.overIcon = new google.maps.MarkerImage(
    "/images/connection_point_icon.png?1",
    new google.maps.Size(18, 18),
    new google.maps.Point(0,0),
    new google.maps.Point(9,9)
  );
  this.outIcon = new google.maps.MarkerImage(
    "/images/connection_point_icon_transparent.png?1",
    new google.maps.Size(18, 18),
    new google.maps.Point(0,0),
    new google.maps.Point(9,9)
  );
  this.icon = this.outIcon;
  this.init(trackPoint.point, {
    zIndex: google.maps.Marker.MAX_ZINDEX + 1,
    raiseOnDrag: false,
    clickable: true,
    draggable: false
  });
  var cp = this;
  google.maps.event.addListener(this.gmarker, 'click', $.proxy(function() {
    var afterConnected = _.once(function() {
      rwgps.Events.unbind('maps:clicks_dispatched', afterConnected);
      var inactiveRoute = trackPoint.nextSegment.route;
      var activeRoute = map.activeRoute;
      if (inactiveRoute.mysqlId && !activeRoute.mysqlId) {
        activeRoute.mysqlId = inactiveRoute.mysqlId
        activeRoute.name = inactiveRoute.name
        activeRoute.routeData = {name: inactiveRoute.name, id: inactiveRoute.routeData.id, isTrip: inactiveRoute.routeData.isTrip}
      }
      map.snapshotsDisabled = true;
      map.removeRoute(inactiveRoute);
      map.snapshotsDisabled = false;
      activeRoute.lastSegment.nextControlPoint.setNextSegment(inactiveRoute.firstSegment);
      activeRoute.segmentsChanged();
      activeRoute.rebuildBounds();
      activeRoute.redraw();

      activeRoute.pois = activeRoute.pois.concat(inactiveRoute.pois);
      map.loadPois(activeRoute.pois)

      var coursePoints = activeRoute.coursePoints();
      map.drawCoursePointIcons(coursePoints);
      map.populateCuesheet(coursePoints);

      var tps = activeRoute.trackPoints();
      map.prevClick = tps[tps.length-1].point;

      activeRoute.calculateMetrics();
      map.drawRouteDistanceMarkers();
      rwgps.Events.trigger('map:routes_changed');
    });
    rwgps.Events.bind('map:clicks_dispatched', afterConnected);
    map.handleClick({
      point: trackPoint.point,
      opts: map.clickOptions,
      color: map.lineColor,
      fetchEles: true
    });
  }, this.map));
  google.maps.event.addListener(this.gmarker, 'mouseover', $.proxy(function() {
    cp.gmarker.setIcon(cp.overIcon);
  }, this.map));
  google.maps.event.addListener(this.gmarker, 'mouseout', $.proxy(function() {
    cp.gmarker.setIcon(cp.outIcon);
  }, this.map));
  if (rwgps.onRightClick) {
    google.maps.event.addListener(this.gmarker, 'rightclick', (e) => rwgps.onRightClick(e, 'connectionPoint', this))
  }
}
rwgps.ConnectionPointIcon.prototype = new rwgps.Icon();

// called by the standalone histogram. takes a start and end index from track points
rwgps.highlightPoints = function(startI, endI, dontChangeView) {
  if(!Routes.activeMap) return;
  var map = Routes.activeMap,
    tps = map.activeRoute.trackPoints().slice(startI, endI),
    latlngs = [];
  _.each(tps, function(pt) { if(pt.point) latlngs.push(pt.googleLatLng()) });

  if(map.highlightedPoints) { rwgps.unhighlightPoints(true); }

  map.highlightedPoints = {
    gPolyline: new google.maps.Polyline({
      path: latlngs,
      map: map.gmap,
      strokeColor: '#0000FF',
      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH,
      clickable: false,
      zIndex: 10000
    }),
    startI: startI,
    endI: endI,
    metrics: (new rwgps.MetricsCalculator(_.map(tps, function(x){return _.clone(x)}))).calculate()
  };
  // zoom to highlighted section
  if(dontChangeView == 'only_metrics') {
    map.onMetricsChange();
  } else if(!dontChangeView) {
    var bounds = new google.maps.LatLngBounds();
    _.each(latlngs, function(pt) { bounds.extend(pt); });
    map.gmap.fitBounds(bounds);
    // show highlighted section metrics
    map.onMetricsChange();
  }
}

rwgps.highlightDataSlice = function(dataSlice, dontChangeView, polylineOptions) {
  //Called by some of the lap timers.
  if (!Routes.activeMap) return;
  var map = Routes.activeMap,
    latlngs = [];
  _.each(dataSlice.points(), function (pt) {
    if (pt.point) latlngs.push(pt.googleLatLng())
  });

  if (map.highlightedPoints) {
    rwgps.unhighlightPoints(true);
  }

  map.highlightedPoints = {
    gPolyline: new google.maps.Polyline($.extend({
      path: latlngs,
      map: map.gmap,
      strokeColor: '#0000FF',
      strokeWeight: rwgps.Route.DEFAULT_LINE_WIDTH,
      clickable: false
    }, polylineOptions)),
    metrics: dataSlice.metrics()
  };
  // zoom to highlighted section
  if (dontChangeView == 'only_metrics') {
    map.onMetricsChange();
  } else if (!dontChangeView) {
    var bounds = new google.maps.LatLngBounds();
    _.each(latlngs, function (pt) {
      bounds.extend(pt);
    });
    map.gmap.fitBounds(bounds);
    // show highlighted section metrics
    map.onMetricsChange();
  }
}

rwgps.zoomToPoint = function(i, zoomLevel) {
  var map = Routes.activeMap,
    pt = map.activeRoute.trackPoints()[i];
  rwgps.zoomToLatLng(pt.point, zoomLevel);
}
rwgps.zoomToLatLng = function(latLng, zoomLevel) {
  var map = Routes.activeMap;
  if(!zoomLevel) zoomLevel = 14;
  map.gmap.setCenter(new google.maps.LatLng(latLng.lat, latLng.lng));
  map.gmap.setZoom(zoomLevel);
}
rwgps.zoomToPoints = function(startI, endI) {
  var map = Routes.activeMap,
      tps = map.activeRoute.trackPoints().slice(startI, endI);
  // filter out points without points
  tps = _.filter(tps, function(x) { return x.point;});

  var bounds = new google.maps.LatLngBounds();
  _.each(tps, function(pt) { bounds.extend(pt.googleLatLng()); });
  map.gmap.fitBounds(bounds);
}
rwgps.unhighlightPoints = function(dontChangeView) {
  var map = Routes.activeMap;
  if(!map || !map.highlightedPoints) { return ; }
  map.highlightedPoints.gPolyline.setMap(null);
  delete map.highlightedPoints;
  if(!dontChangeView) {
    // zoom out
    map.recenterMap();
    // show active route metrics
    map.onMetricsChange();
  }
}
rwgps.recenterMap = function() {
  Routes.activeMap.recenterMap();
}
// trackpoints (tps) is optional
rwgps.highlightPoint = function(i, pct) {
  var map = Routes.activeMap,
    tps = map.activeRoute.trackPoints(),
    pt = tps[i];
  if(!pt) return;
  var point = pt.point;
  if(!point) return; // need a point to highlight... bail out if it doesn't exist.

  if(map.keepPlayheadStopped) return;

  var lastPt = tps[i - 1];
  if(i > 0 && pct && lastPt.point) {
    var lat1 = lastPt.point.lat,
      lng1 = lastPt.point.lng,
      lat2 = point.lat,
      lng2 = point.lng,
      newLat = (lat2 - lat1) * pct + lat1,
      newLng = (lng2 - lng1) * pct + lng1;

    point = {lat: newLat, lng: newLng};
  }
  if(map._playing) {
    if($('#playback_autoCenter').is(':checked')) {
      map.gmap.setCenter(new google.maps.LatLng(newLat, newLng));
    }
  }
  map.showNearestPointMarkerAt(point);

  map.updatePlayhead(pt, tps);

}

rwgps.showMarker = function(lng, lat, id) {
  var map = Routes.activeMap,
      latLng = new google.maps.LatLng(lat, lng);

  if(!rwgps.markerSet) rwgps.markerSet = {};
  var set = rwgps.markerSet;

  if(!set[id]) {
    var icon = _.size(set) % 10 + 1
    set[id] = new rwgps.RacerIcon(latLng, map, icon);
  }

  if(set[id].gmarker.getMap() == null) set[id].gmarker.setMap(map.gmap);
  if(set[id].gmarker.getVisible() == false) set[id].gmarker.setVisible(true);
  set[id].gmarker.setPosition(latLng);
  set[id].gmarker.setZIndex(0); //hack, setPosition seems to reset zindex to top :(
}

rwgps.removeMarker = function(id) {
  if(rwgps.markerSet && rwgps.markerSet[id]) {
    rwgps.markerSet[id].gmarker.setMap(null);
    delete rwgps.markerSet[id];
  }
}


// distance marker stuff
rwgps.Map.prototype.updateDistanceMarkersDisplayed = function() {
  if(!this.gmap || !this.opts.distanceMarkersEnabled) return;

  var i, zoom = this.gmap.getZoom();
  if(rwgps.LabelMaker.metric) {
    if(zoom >= 14) i = 0;
    else if(zoom >= 13) i = 1;
    else if(zoom >= 12) i = 2;
    else if(zoom >= 10) i = 3;
    else i = 4;
  } else {
    if(zoom >= 13) i = 0;
    else if(zoom >= 12) i = 1;
    else if(zoom >= 11) i = 2;
    else if(zoom >= 9) i = 3;
    else i = 4;
  }

  if (i !== this._distanceMarkerLevel) {
    // hide the previously shown set
    if (this.distanceMarkers[this._distanceMarkerLevel]) {
      this.distanceMarkers[this._distanceMarkerLevel].forEach(({marker}) => marker.setMap(null))
    }

    this._distanceMarkerLevel = i
  }

  // we don't show any distance markers when i === 4
  const bounds = this.gmap.getBounds()
  if(i < 4 && bounds) {
    // display all markers currently visible in viewport, hide others
    this.distanceMarkers[i].forEach(({marker}) => {
      if (bounds.contains(marker.latLng)) {
        if (!marker.getMap()) {
          marker.setMap(this.gmap)
        }
      } else {
        marker.setMap(null)
      }
    })
  }
}

rwgps.Map.prototype.removeSegmentDistanceMarkers = function(segment) {
  _.each(segment.distanceMarkers, function(marker) {
    try {
      marker.setMap(null);
    } catch(e) { } // eslint-disable-line no-empty

    _.each(this.distanceMarkers, function(arr) {
      _.each(arr, function(o, i) {
        try {
          if(marker === o.marker) arr.splice(i, 1);
        } catch(e) {} // eslint-disable-line no-empty
      });
    });
  }, this);
  segment.distanceMarkers = [];
}

rwgps.Map.prototype.removeRouteDistanceMarkers = function(route) {
  if (this._updateDistanceMarkersListener) {
    this._updateDistanceMarkersListener.remove()
    this._updateDistanceMarkersListener = null
  }

  this.distanceMarkers = [[],[], [], []];
  _.each(route.segments, function(seg) {
    seg.distanceMarkers.forEach(marker => marker.setMap(null))
    seg.distanceMarkers = [];
  });
  // will force a redraw on next updateDistanceMarkersDisplayed call
  this._distanceMarkerLevel = null
}

rwgps.Map.prototype.drawRouteDistanceMarkers = function(route) {
  if(!route) route = this.activeRoute;
  this.removeRouteDistanceMarkers(route);
  _.each(route.segments, function(seg) {
    this.drawSegmentDistanceMarkers(seg, true);
  }, this);
  this.updateDistanceMarkersDisplayed();
  if (this.gmap) {
    this._updateDistanceMarkersListener = this.gmap.addListener('bounds_changed', _.throttle(this.updateDistanceMarkersDisplayed.bind(this), 200))
  }
}


function DistanceMarker(val, latLng) {
  if (!DistanceMarker.prototype.setValues) {
    // Use the hack described at https://github.com/googlemaps/js-map-label/issues/1
    // to allow for async loading of google.maps
    for (var prop in google.maps.OverlayView.prototype) {
        DistanceMarker.prototype[prop] = google.maps.OverlayView.prototype[prop];
    }
  }
  this.val = val
  this.latLng = latLng
}

DistanceMarker.prototype.onAdd = function() {
  const iconSrc = `/images/distance_marker_icon${this.val >= 1000 ? '_wide' : ''}.png?1`
  this.el = $(`<div class="distanceMarkerLabel"><img src="${iconSrc}" /><span class="${this.val < 10 ? 'lt10' : (this.val < 100 ? 'lt100' : (this.val < 1000 ? 'lt1000' : 'gte1000'))}">${this.val}</span></div>`).get(0)
  this.el.style.position = 'absolute'
  this.getPanes().markerLayer.appendChild(this.el)
}
DistanceMarker.prototype.draw = function() {
  const point = this.getProjection().fromLatLngToDivPixel(this.latLng);
  if (point) {
    this.el.style.left = point.x + 'px';
    this.el.style.top = point.y + 'px';
  }
}
DistanceMarker.prototype.onRemove = function() {
  this.el && this.el.parentNode.removeChild(this.el)
}

rwgps.Map.prototype.drawSegmentDistanceMarkers = function(seg, dontRedisplay) {
  if(!this.opts.distanceMarkersEnabled) return;
  var prevPoint = seg.prevControlPoint;
  var metersInUnit = (rwgps.LabelMaker.metric ? 1000 : 1609.344);

  for(var i = 0, len = seg.trackPoints.length; i < len; i++) {
    var point = seg.trackPoints[i];
    if(!point.point) continue;
    var val = Math.floor(point.distanceWithoutExcludedPoints / metersInUnit),
        prevVal = Math.floor(prevPoint.distanceWithoutExcludedPoints / metersInUnit);

    if(val != prevVal && point.point && prevPoint.point) {
      //we changed from a whole km or mi between these two points
      //now linearly interpolate to find lat/lng of place to put marker
      var latDiff = point.point.lat - prevPoint.point.lat;
      var lngDiff = point.point.lng - prevPoint.point.lng;
      var distDiff = point.distanceWithoutExcludedPoints - prevPoint.distanceWithoutExcludedPoints;
      var percent = (val*metersInUnit - prevPoint.distanceWithoutExcludedPoints) / distDiff;

      //now we have percent saying how much along the line to interpolate
      var newLat = prevPoint.point.lat + latDiff*percent;
      var newLng = prevPoint.point.lng + lngDiff*percent;

      var marker = new DistanceMarker(val, new google.maps.LatLng(newLat, newLng))

      var marker_obj = {lat:newLat, lng:newLng, marker:marker};
      if(val % 25 == 0)
        this.distanceMarkers[3].push(marker_obj);
      if(val % 5 == 0)
        this.distanceMarkers[2].push(marker_obj);
      if(val % 2 == 0)
        this.distanceMarkers[1].push(marker_obj);

      this.distanceMarkers[0].push(marker_obj);

      seg.distanceMarkers.push(marker_obj.marker);
    }

    prevPoint = point;
  }
  if(!dontRedisplay) this.updateDistanceMarkersDisplayed();
}

rwgps.Map.prototype.distanceMarkersEnabled = function(b) {
  this.opts.distanceMarkersEnabled = b;
  this.drawRouteDistanceMarkers(this.activeRoute);
};

rwgps.Map.prototype.generateCues = function(b) {
  this.opts.generateCues = b;
};

rwgps.Map.prototype.drawImageMarkers = function(photos) {
  this.imageMarkers = {};
  _.each(photos, function(photo) {
    if(photo.lat && photo.lng) {
      var marker = new google.maps.Marker({
        map: this.gmap,
        icon: '/images/image_marker.png?1',
        position: new google.maps.LatLng(photo.lat, photo.lng),
        clickable: true
      });
      google.maps.event.addListener(marker, 'click', function() {
        if(marker.selected) {
          $('.mini_slideshow .item.active a.popup_photo_modal').click();
        } else {
          var idx = $('.mini_slideshow .item').index($('.mini_slideshow img.ss_img[data-photo-id=' + photo.id + ']').closest('.item'));
          $('.mini_slideshow').carousel(idx);
        }
      });
      this.imageMarkers[photo.id] = marker;
    }
  }, this);
};



// WEBPACK FOOTER //
// ./public/javascripts/js_maps/map.js